const Districts = () => {
    return (
        {
            "Andaman and Nicobar Islands": {
                "districtData": {
                    "Nicobars": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "North and Middle Andaman": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 0,
                        "confirmed": 1,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "South Andaman": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 19,
                        "confirmed": 51,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 32,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -13,
                        "confirmed": 7496,
                        "migratedother": 0,
                        "deceased": 129,
                        "recovered": 7380,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "AN"
            },
            "Andhra Pradesh": {
                "districtData": {
                    "Foreign Evacuees": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 434,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 434,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Anantapur": {
                        "notes": "",
                        "active": 247,
                        "confirmed": 156673,
                        "migratedother": 0,
                        "deceased": 1089,
                        "recovered": 155337,
                        "delta": {
                            "confirmed": 51,
                            "deceased": 1,
                            "recovered": 45
                        }
                    },
                    "Chittoor": {
                        "notes": "",
                        "active": 2778,
                        "confirmed": 234198,
                        "migratedother": 0,
                        "deceased": 1783,
                        "recovered": 229637,
                        "delta": {
                            "confirmed": 175,
                            "deceased": 5,
                            "recovered": 360
                        }
                    },
                    "East Godavari": {
                        "notes": "",
                        "active": 3065,
                        "confirmed": 281384,
                        "migratedother": 0,
                        "deceased": 1232,
                        "recovered": 277087,
                        "delta": {
                            "confirmed": 385,
                            "deceased": 1,
                            "recovered": 502
                        }
                    },
                    "Guntur": {
                        "notes": "",
                        "active": 1605,
                        "confirmed": 169978,
                        "migratedother": 0,
                        "deceased": 1163,
                        "recovered": 167210,
                        "delta": {
                            "confirmed": 222,
                            "deceased": 2,
                            "recovered": 211
                        }
                    },
                    "Krishna": {
                        "notes": "",
                        "active": 3111,
                        "confirmed": 111221,
                        "migratedother": 0,
                        "deceased": 1250,
                        "recovered": 106860,
                        "delta": {
                            "confirmed": 148,
                            "deceased": 3,
                            "recovered": 187
                        }
                    },
                    "Kurnool": {
                        "notes": "",
                        "active": 216,
                        "confirmed": 123525,
                        "migratedother": 0,
                        "deceased": 844,
                        "recovered": 122465,
                        "delta": {
                            "confirmed": 10,
                            "deceased": 0,
                            "recovered": 26
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 2461,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2461,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Prakasam": {
                        "notes": "",
                        "active": 1470,
                        "confirmed": 131478,
                        "migratedother": 0,
                        "deceased": 1023,
                        "recovered": 128985,
                        "delta": {
                            "confirmed": 98,
                            "deceased": 3,
                            "recovered": 188
                        }
                    },
                    "S.P.S. Nellore": {
                        "notes": "",
                        "active": 2591,
                        "confirmed": 136685,
                        "migratedother": 0,
                        "deceased": 973,
                        "recovered": 133121,
                        "delta": {
                            "confirmed": 177,
                            "deceased": 1,
                            "recovered": 168
                        }
                    },
                    "Srikakulam": {
                        "notes": "",
                        "active": 557,
                        "confirmed": 121217,
                        "migratedother": 0,
                        "deceased": 769,
                        "recovered": 119891,
                        "delta": {
                            "confirmed": 82,
                            "deceased": 0,
                            "recovered": 45
                        }
                    },
                    "Visakhapatnam": {
                        "notes": "",
                        "active": 544,
                        "confirmed": 153395,
                        "migratedother": 0,
                        "deceased": 1089,
                        "recovered": 151762,
                        "delta": {
                            "confirmed": 63,
                            "deceased": 1,
                            "recovered": 181
                        }
                    },
                    "Vizianagaram": {
                        "notes": "",
                        "active": 225,
                        "confirmed": 81707,
                        "migratedother": 0,
                        "deceased": 669,
                        "recovered": 80813,
                        "delta": {
                            "confirmed": 21,
                            "deceased": 0,
                            "recovered": 16
                        }
                    },
                    "West Godavari": {
                        "notes": "",
                        "active": 1422,
                        "confirmed": 171354,
                        "migratedother": 0,
                        "deceased": 1071,
                        "recovered": 168861,
                        "delta": {
                            "confirmed": 304,
                            "deceased": 1,
                            "recovered": 243
                        }
                    },
                    "Y.S.R. Kadapa": {
                        "notes": "",
                        "active": 586,
                        "confirmed": 111341,
                        "migratedother": 0,
                        "deceased": 627,
                        "recovered": 110128,
                        "delta": {
                            "confirmed": 133,
                            "deceased": 0,
                            "recovered": 144
                        }
                    }
                },
                "statecode": "AP"
            },
            "Arunachal Pradesh": {
                "districtData": {
                    "Anjaw": {
                        "notes": "",
                        "active": 48,
                        "confirmed": 985,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 934,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Changlang": {
                        "notes": "",
                        "active": 71,
                        "confirmed": 3621,
                        "migratedother": 0,
                        "deceased": 20,
                        "recovered": 3530,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "East Kameng": {
                        "notes": "",
                        "active": 35,
                        "confirmed": 1066,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1031,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "East Siang": {
                        "notes": "",
                        "active": 102,
                        "confirmed": 2936,
                        "migratedother": 0,
                        "deceased": 17,
                        "recovered": 2817,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Kamle": {
                        "notes": "",
                        "active": 60,
                        "confirmed": 460,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 400,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Kra Daadi": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 256,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 249,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kurung Kumey": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 507,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 504,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Lepa Rada": {
                        "notes": "",
                        "active": 41,
                        "confirmed": 762,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 719,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Lohit": {
                        "notes": "",
                        "active": 144,
                        "confirmed": 2656,
                        "migratedother": 0,
                        "deceased": 26,
                        "recovered": 2486,
                        "delta": {
                            "confirmed": 11,
                            "deceased": 1,
                            "recovered": 5
                        }
                    },
                    "Longding": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 728,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 712,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Lower Dibang Valley": {
                        "notes": "",
                        "active": 89,
                        "confirmed": 2147,
                        "migratedother": 0,
                        "deceased": 9,
                        "recovered": 2049,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Lower Siang": {
                        "notes": "",
                        "active": 50,
                        "confirmed": 703,
                        "migratedother": 0,
                        "deceased": 8,
                        "recovered": 645,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 14
                        }
                    },
                    "Lower Subansiri": {
                        "notes": "",
                        "active": 333,
                        "confirmed": 2610,
                        "migratedother": 0,
                        "deceased": 11,
                        "recovered": 2266,
                        "delta": {
                            "confirmed": 15,
                            "deceased": 0,
                            "recovered": 17
                        }
                    },
                    "Namsai": {
                        "notes": "",
                        "active": 48,
                        "confirmed": 1958,
                        "migratedother": 0,
                        "deceased": 15,
                        "recovered": 1895,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pakke Kessang": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 390,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 381,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Papum Pare": {
                        "notes": "",
                        "active": 844,
                        "confirmed": 17113,
                        "migratedother": 0,
                        "deceased": 87,
                        "recovered": 16182,
                        "delta": {
                            "confirmed": 65,
                            "deceased": 1,
                            "recovered": 112
                        }
                    },
                    "Shi Yomi": {
                        "notes": "",
                        "active": 25,
                        "confirmed": 221,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 196,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Siang": {
                        "notes": "",
                        "active": 27,
                        "confirmed": 393,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 363,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Tawang": {
                        "notes": "",
                        "active": 115,
                        "confirmed": 2283,
                        "migratedother": 0,
                        "deceased": 17,
                        "recovered": 2151,
                        "delta": {
                            "confirmed": 12,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Tirap": {
                        "notes": "",
                        "active": 20,
                        "confirmed": 1005,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 982,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Upper Dibang Valley": {
                        "notes": "",
                        "active": 26,
                        "confirmed": 290,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 262,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Upper Siang": {
                        "notes": "",
                        "active": 76,
                        "confirmed": 881,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 804,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Upper Subansiri": {
                        "notes": "",
                        "active": 80,
                        "confirmed": 1903,
                        "migratedother": 0,
                        "deceased": 6,
                        "recovered": 1817,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 1,
                            "recovered": 1
                        }
                    },
                    "West Kameng": {
                        "notes": "",
                        "active": 171,
                        "confirmed": 3194,
                        "migratedother": 0,
                        "deceased": 13,
                        "recovered": 3010,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 15
                        }
                    },
                    "West Siang": {
                        "notes": "",
                        "active": 51,
                        "confirmed": 1725,
                        "migratedother": 0,
                        "deceased": 5,
                        "recovered": 1669,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 17
                        }
                    }
                },
                "statecode": "AR"
            },
            "Assam": {
                "districtData": {
                    "Airport Quarantine": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 13,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 13,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Baksa": {
                        "notes": "",
                        "active": 5510,
                        "confirmed": 6013,
                        "migratedother": 0,
                        "deceased": 56,
                        "recovered": 447,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Barpeta": {
                        "notes": "",
                        "active": 10368,
                        "confirmed": 11543,
                        "migratedother": 0,
                        "deceased": 151,
                        "recovered": 1024,
                        "delta": {
                            "confirmed": 72,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Biswanath": {
                        "notes": "",
                        "active": 8010,
                        "confirmed": 8439,
                        "migratedother": 0,
                        "deceased": 50,
                        "recovered": 379,
                        "delta": {
                            "confirmed": 34,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bongaigaon": {
                        "notes": "",
                        "active": 5321,
                        "confirmed": 6222,
                        "migratedother": 0,
                        "deceased": 67,
                        "recovered": 834,
                        "delta": {
                            "confirmed": 14,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Cachar": {
                        "notes": "",
                        "active": 22029,
                        "confirmed": 23713,
                        "migratedother": 0,
                        "deceased": 186,
                        "recovered": 1498,
                        "delta": {
                            "confirmed": 21,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Charaideo": {
                        "notes": "",
                        "active": 3312,
                        "confirmed": 3464,
                        "migratedother": 0,
                        "deceased": 47,
                        "recovered": 105,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chirang": {
                        "notes": "",
                        "active": 2353,
                        "confirmed": 2606,
                        "migratedother": 0,
                        "deceased": 34,
                        "recovered": 219,
                        "delta": {
                            "confirmed": 14,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Darrang": {
                        "notes": "",
                        "active": 8315,
                        "confirmed": 10144,
                        "migratedother": 0,
                        "deceased": 99,
                        "recovered": 1730,
                        "delta": {
                            "confirmed": 18,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dhemaji": {
                        "notes": "",
                        "active": 6769,
                        "confirmed": 7248,
                        "migratedother": 0,
                        "deceased": 39,
                        "recovered": 440,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dhubri": {
                        "notes": "",
                        "active": 6590,
                        "confirmed": 7856,
                        "migratedother": 0,
                        "deceased": 51,
                        "recovered": 1215,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Dibrugarh": {
                        "notes": "",
                        "active": 30197,
                        "confirmed": 32973,
                        "migratedother": 0,
                        "deceased": 367,
                        "recovered": 2409,
                        "delta": {
                            "confirmed": 42,
                            "deceased": 2,
                            "recovered": 0
                        }
                    },
                    "Dima Hasao": {
                        "notes": "",
                        "active": 2880,
                        "confirmed": 3091,
                        "migratedother": 0,
                        "deceased": 12,
                        "recovered": 199,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Goalpara": {
                        "notes": "",
                        "active": 38,
                        "confirmed": 10532,
                        "migratedother": 0,
                        "deceased": 81,
                        "recovered": 568,
                        "delta": {
                            "confirmed": 19,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Golaghat": {
                        "notes": "",
                        "active": 19914,
                        "confirmed": 21779,
                        "migratedother": 0,
                        "deceased": 209,
                        "recovered": 1656,
                        "delta": {
                            "confirmed": 50,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hailakandi": {
                        "notes": "",
                        "active": 4929,
                        "confirmed": 6079,
                        "migratedother": 0,
                        "deceased": 34,
                        "recovered": 1116,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hojai": {
                        "notes": "",
                        "active": 5795,
                        "confirmed": 7058,
                        "migratedother": 0,
                        "deceased": 103,
                        "recovered": 1160,
                        "delta": {
                            "confirmed": 17,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jorhat": {
                        "notes": "",
                        "active": 21134,
                        "confirmed": 23152,
                        "migratedother": 0,
                        "deceased": 266,
                        "recovered": 1752,
                        "delta": {
                            "confirmed": 38,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kamrup": {
                        "notes": "",
                        "active": 28948,
                        "confirmed": 31268,
                        "migratedother": 0,
                        "deceased": 246,
                        "recovered": 2074,
                        "delta": {
                            "confirmed": 46,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Kamrup Metropolitan": {
                        "notes": "",
                        "active": 86012,
                        "confirmed": 102179,
                        "migratedother": 0,
                        "deceased": 797,
                        "recovered": 15370,
                        "delta": {
                            "confirmed": 161,
                            "deceased": 2,
                            "recovered": 0
                        }
                    },
                    "Karbi Anglong": {
                        "notes": "",
                        "active": 6131,
                        "confirmed": 6787,
                        "migratedother": 0,
                        "deceased": 104,
                        "recovered": 552,
                        "delta": {
                            "confirmed": 17,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Karimganj": {
                        "notes": "",
                        "active": 6649,
                        "confirmed": 7690,
                        "migratedother": 0,
                        "deceased": 86,
                        "recovered": 955,
                        "delta": {
                            "confirmed": 10,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kokrajhar": {
                        "notes": "",
                        "active": 4898,
                        "confirmed": 5311,
                        "migratedother": 0,
                        "deceased": 60,
                        "recovered": 353,
                        "delta": {
                            "confirmed": 11,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Lakhimpur": {
                        "notes": "",
                        "active": 12699,
                        "confirmed": 13925,
                        "migratedother": 0,
                        "deceased": 91,
                        "recovered": 1135,
                        "delta": {
                            "confirmed": 42,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Majuli": {
                        "notes": "",
                        "active": 1686,
                        "confirmed": 1774,
                        "migratedother": 0,
                        "deceased": 8,
                        "recovered": 80,
                        "delta": {
                            "confirmed": 11,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Morigaon": {
                        "notes": "",
                        "active": 12264,
                        "confirmed": 12888,
                        "migratedother": 0,
                        "deceased": 67,
                        "recovered": 557,
                        "delta": {
                            "confirmed": 32,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nagaon": {
                        "notes": "",
                        "active": 20934,
                        "confirmed": 23628,
                        "migratedother": 0,
                        "deceased": 188,
                        "recovered": 2506,
                        "delta": {
                            "confirmed": 34,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Nalbari": {
                        "notes": "",
                        "active": 8686,
                        "confirmed": 9612,
                        "migratedother": 0,
                        "deceased": 98,
                        "recovered": 828,
                        "delta": {
                            "confirmed": 41,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 152,
                        "confirmed": 153,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sivasagar": {
                        "notes": "",
                        "active": 9278,
                        "confirmed": 9911,
                        "migratedother": 0,
                        "deceased": 160,
                        "recovered": 473,
                        "delta": {
                            "confirmed": 17,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Sonitpur": {
                        "notes": "",
                        "active": 17905,
                        "confirmed": 19836,
                        "migratedother": 0,
                        "deceased": 204,
                        "recovered": 1727,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "South Salmara Mankachar": {
                        "notes": "",
                        "active": 1776,
                        "confirmed": 1839,
                        "migratedother": 0,
                        "deceased": 16,
                        "recovered": 47,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tinsukia": {
                        "notes": "",
                        "active": 17346,
                        "confirmed": 19387,
                        "migratedother": 0,
                        "deceased": 243,
                        "recovered": 1798,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Udalguri": {
                        "notes": "",
                        "active": 4684,
                        "confirmed": 5418,
                        "migratedother": 0,
                        "deceased": 68,
                        "recovered": 666,
                        "delta": {
                            "confirmed": 14,
                            "deceased": 2,
                            "recovered": 0
                        }
                    },
                    "West Karbi Anglong": {
                        "notes": "",
                        "active": 1193,
                        "confirmed": 1233,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 37,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -405078,
                        "confirmed": 112271,
                        "migratedother": 1347,
                        "deceased": 1143,
                        "recovered": 514859,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "AS"
            },
            "Bihar": {
                "districtData": {
                    "Araria": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 14958,
                        "migratedother": 0,
                        "deceased": 116,
                        "recovered": 14834,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Arwal": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 7377,
                        "migratedother": 0,
                        "deceased": 74,
                        "recovered": 7295,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Aurangabad": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 20009,
                        "migratedother": 0,
                        "deceased": 75,
                        "recovered": 19934,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Banka": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 7378,
                        "migratedother": 0,
                        "deceased": 112,
                        "recovered": 7266,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Begusarai": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 27181,
                        "migratedother": 0,
                        "deceased": 457,
                        "recovered": 26717,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Bhagalpur": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 25825,
                        "migratedother": 0,
                        "deceased": 309,
                        "recovered": 25504,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Bhojpur": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 10172,
                        "migratedother": 0,
                        "deceased": 159,
                        "recovered": 10004,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Buxar": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 9248,
                        "migratedother": 0,
                        "deceased": 182,
                        "recovered": 9066,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Darbhanga": {
                        "notes": "",
                        "active": 27,
                        "confirmed": 10897,
                        "migratedother": 0,
                        "deceased": 366,
                        "recovered": 10504,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": -1
                        }
                    },
                    "East Champaran": {
                        "notes": "",
                        "active": 22,
                        "confirmed": 19000,
                        "migratedother": 0,
                        "deceased": 430,
                        "recovered": 18548,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Gaya": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 33937,
                        "migratedother": 0,
                        "deceased": 279,
                        "recovered": 33652,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Gopalganj": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 16671,
                        "migratedother": 0,
                        "deceased": 94,
                        "recovered": 16576,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Jamui": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 9410,
                        "migratedother": 0,
                        "deceased": 106,
                        "recovered": 9300,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Jehanabad": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 10770,
                        "migratedother": 0,
                        "deceased": 109,
                        "recovered": 10661,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kaimur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 4983,
                        "migratedother": 0,
                        "deceased": 147,
                        "recovered": 4836,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Katihar": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 18119,
                        "migratedother": 0,
                        "deceased": 94,
                        "recovered": 18011,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Khagaria": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 10054,
                        "migratedother": 0,
                        "deceased": 88,
                        "recovered": 9966,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Kishanganj": {
                        "notes": "",
                        "active": 15,
                        "confirmed": 10103,
                        "migratedother": 0,
                        "deceased": 66,
                        "recovered": 10022,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Lakhisarai": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 7768,
                        "migratedother": 0,
                        "deceased": 102,
                        "recovered": 7660,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Madhepura": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 12519,
                        "migratedother": 0,
                        "deceased": 111,
                        "recovered": 12400,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Madhubani": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 18332,
                        "migratedother": 0,
                        "deceased": 337,
                        "recovered": 17991,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Munger": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 15101,
                        "migratedother": 0,
                        "deceased": 158,
                        "recovered": 14940,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Muzaffarpur": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 31379,
                        "migratedother": 0,
                        "deceased": 621,
                        "recovered": 30746,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Nalanda": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 23421,
                        "migratedother": 0,
                        "deceased": 468,
                        "recovered": 22939,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nawada": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 10344,
                        "migratedother": 0,
                        "deceased": 178,
                        "recovered": 10164,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Patna": {
                        "notes": "",
                        "active": 38,
                        "confirmed": 146831,
                        "migratedother": 0,
                        "deceased": 2330,
                        "recovered": 144463,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Purnia": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 24406,
                        "migratedother": 0,
                        "deceased": 180,
                        "recovered": 24223,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rohtas": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 13958,
                        "migratedother": 0,
                        "deceased": 269,
                        "recovered": 13682,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Saharsa": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 17591,
                        "migratedother": 0,
                        "deceased": 134,
                        "recovered": 17454,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Samastipur": {
                        "notes": "",
                        "active": 19,
                        "confirmed": 19977,
                        "migratedother": 0,
                        "deceased": 154,
                        "recovered": 19804,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Saran": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 23267,
                        "migratedother": 0,
                        "deceased": 255,
                        "recovered": 23011,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Sheikhpura": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 7690,
                        "migratedother": 0,
                        "deceased": 75,
                        "recovered": 7613,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sheohar": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 4395,
                        "migratedother": 0,
                        "deceased": 36,
                        "recovered": 4358,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Sitamarhi": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 9169,
                        "migratedother": 0,
                        "deceased": 127,
                        "recovered": 9039,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Siwan": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 15193,
                        "migratedother": 0,
                        "deceased": 170,
                        "recovered": 15023,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Supaul": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 17202,
                        "migratedother": 0,
                        "deceased": 128,
                        "recovered": 17073,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Vaishali": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 19806,
                        "migratedother": 1,
                        "deceased": 192,
                        "recovered": 19601,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "West Champaran": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 20885,
                        "migratedother": 0,
                        "deceased": 358,
                        "recovered": 20523,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    }
                },
                "statecode": "BR"
            },
            "Chandigarh": {
                "districtData": {
                    "Chandigarh": {
                        "notes": "",
                        "active": 35,
                        "confirmed": 61997,
                        "migratedother": 0,
                        "deceased": 811,
                        "recovered": 61151,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 1
                        }
                    }
                },
                "statecode": "CH"
            },
            "Chhattisgarh": {
                "districtData": {
                    "Other State": {
                        "notes": "",
                        "active": 19,
                        "confirmed": 766,
                        "migratedother": 0,
                        "deceased": 131,
                        "recovered": 616,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Balod": {
                        "notes": "",
                        "active": 23,
                        "confirmed": 27256,
                        "migratedother": 0,
                        "deceased": 396,
                        "recovered": 26837,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Baloda Bazar": {
                        "notes": "",
                        "active": 124,
                        "confirmed": 43005,
                        "migratedother": 0,
                        "deceased": 470,
                        "recovered": 42411,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Balrampur": {
                        "notes": "",
                        "active": 30,
                        "confirmed": 20276,
                        "migratedother": 0,
                        "deceased": 118,
                        "recovered": 20128,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bametara": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 19943,
                        "migratedother": 0,
                        "deceased": 236,
                        "recovered": 19701,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bastar": {
                        "notes": "",
                        "active": 154,
                        "confirmed": 20927,
                        "migratedother": 0,
                        "deceased": 188,
                        "recovered": 20585,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Bijapur": {
                        "notes": "",
                        "active": 50,
                        "confirmed": 8255,
                        "migratedother": 0,
                        "deceased": 54,
                        "recovered": 8151,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Bilaspur": {
                        "notes": "",
                        "active": 82,
                        "confirmed": 65457,
                        "migratedother": 0,
                        "deceased": 1205,
                        "recovered": 64170,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Dakshin Bastar Dantewada": {
                        "notes": "",
                        "active": 30,
                        "confirmed": 10746,
                        "migratedother": 0,
                        "deceased": 24,
                        "recovered": 10692,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 12
                        }
                    },
                    "Dhamtari": {
                        "notes": "",
                        "active": 33,
                        "confirmed": 27188,
                        "migratedother": 0,
                        "deceased": 544,
                        "recovered": 26611,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Durg": {
                        "notes": "",
                        "active": 127,
                        "confirmed": 96644,
                        "migratedother": 0,
                        "deceased": 1794,
                        "recovered": 94723,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Gariaband": {
                        "notes": "",
                        "active": 22,
                        "confirmed": 19668,
                        "migratedother": 0,
                        "deceased": 194,
                        "recovered": 19452,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Janjgir Champa": {
                        "notes": "",
                        "active": 102,
                        "confirmed": 57429,
                        "migratedother": 0,
                        "deceased": 830,
                        "recovered": 56497,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 17
                        }
                    },
                    "Jashpur": {
                        "notes": "",
                        "active": 92,
                        "confirmed": 26924,
                        "migratedother": 0,
                        "deceased": 212,
                        "recovered": 26620,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Kabeerdham": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 22768,
                        "migratedother": 0,
                        "deceased": 267,
                        "recovered": 22492,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kondagaon": {
                        "notes": "",
                        "active": 24,
                        "confirmed": 13062,
                        "migratedother": 0,
                        "deceased": 99,
                        "recovered": 12939,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Korba": {
                        "notes": "",
                        "active": 66,
                        "confirmed": 54569,
                        "migratedother": 0,
                        "deceased": 575,
                        "recovered": 53928,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Koriya": {
                        "notes": "",
                        "active": 41,
                        "confirmed": 26918,
                        "migratedother": 0,
                        "deceased": 175,
                        "recovered": 26702,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Mahasamund": {
                        "notes": "",
                        "active": 33,
                        "confirmed": 31319,
                        "migratedother": 0,
                        "deceased": 364,
                        "recovered": 30922,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 1,
                            "recovered": 5
                        }
                    },
                    "Mungeli": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 23891,
                        "migratedother": 0,
                        "deceased": 167,
                        "recovered": 23710,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Narayanpur": {
                        "notes": "",
                        "active": 30,
                        "confirmed": 4003,
                        "migratedother": 0,
                        "deceased": 14,
                        "recovered": 3959,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Raigarh": {
                        "notes": "",
                        "active": 60,
                        "confirmed": 62463,
                        "migratedother": 0,
                        "deceased": 978,
                        "recovered": 61425,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 10
                        }
                    },
                    "Raipur": {
                        "notes": "",
                        "active": 121,
                        "confirmed": 157796,
                        "migratedother": 0,
                        "deceased": 3139,
                        "recovered": 154536,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 9
                        }
                    },
                    "Rajnandgaon": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 56011,
                        "migratedother": 0,
                        "deceased": 514,
                        "recovered": 55485,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Sukma": {
                        "notes": "",
                        "active": 48,
                        "confirmed": 7967,
                        "migratedother": 0,
                        "deceased": 20,
                        "recovered": 7899,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Surajpur": {
                        "notes": "",
                        "active": 40,
                        "confirmed": 29015,
                        "migratedother": 0,
                        "deceased": 224,
                        "recovered": 28751,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Surguja": {
                        "notes": "",
                        "active": 34,
                        "confirmed": 33638,
                        "migratedother": 0,
                        "deceased": 245,
                        "recovered": 33359,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Uttar Bastar Kanker": {
                        "notes": "",
                        "active": 118,
                        "confirmed": 23530,
                        "migratedother": 0,
                        "deceased": 222,
                        "recovered": 23190,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Gaurela Pendra Marwahi": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 12005,
                        "migratedother": 0,
                        "deceased": 146,
                        "recovered": 11846,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "CT"
            },
            "Delhi": {
                "districtData": {
                    "Central Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 184,
                        "confirmed": 184,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "East Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 38,
                        "confirmed": 38,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "New Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 37,
                        "confirmed": 37,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "North Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 60,
                        "confirmed": 60,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "North East Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 25,
                        "confirmed": 25,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "North West Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 31,
                        "confirmed": 32,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shahdara": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 48,
                        "confirmed": 48,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "South Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 70,
                        "confirmed": 70,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "South East Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 130,
                        "confirmed": 130,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "South West Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 42,
                        "confirmed": 42,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "West Delhi": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 122,
                        "confirmed": 122,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -293,
                        "confirmed": 1436101,
                        "migratedother": 0,
                        "deceased": 25067,
                        "recovered": 1411327,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "DL"
            },
            "Dadra and Nagar Haveli and Daman and Diu": {
                "districtData": {
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dadra and Nagar Haveli": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 5905,
                        "migratedother": 5,
                        "deceased": 3,
                        "recovered": 5894,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Daman": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 3534,
                        "migratedother": 26,
                        "deceased": 1,
                        "recovered": 3506,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Diu": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 1218,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1215,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "DN"
            },
            "Goa": {
                "districtData": {
                    "Other State": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 9,
                        "confirmed": 200,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 190,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "North Goa": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 1639,
                        "confirmed": 2668,
                        "migratedother": 0,
                        "deceased": 65,
                        "recovered": 964,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "South Goa": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in bulletin",
                        "active": 1978,
                        "confirmed": 3511,
                        "migratedother": 0,
                        "deceased": 126,
                        "recovered": 1407,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -2643,
                        "confirmed": 165809,
                        "migratedother": 0,
                        "deceased": 2972,
                        "recovered": 165480,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "GA"
            },
            "Gujarat": {
                "districtData": {
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 162,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 159,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ahmedabad": {
                        "notes": "",
                        "active": 61,
                        "confirmed": 238022,
                        "migratedother": 0,
                        "deceased": 3411,
                        "recovered": 234550,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Amreli": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 10806,
                        "migratedother": 0,
                        "deceased": 102,
                        "recovered": 10700,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Anand": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 9623,
                        "migratedother": 0,
                        "deceased": 49,
                        "recovered": 9569,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Aravalli": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 5183,
                        "migratedother": 0,
                        "deceased": 78,
                        "recovered": 5105,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Banaskantha": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 13631,
                        "migratedother": 0,
                        "deceased": 162,
                        "recovered": 13469,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Bharuch": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 11425,
                        "migratedother": 0,
                        "deceased": 118,
                        "recovered": 11304,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bhavnagar": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 21413,
                        "migratedother": 0,
                        "deceased": 300,
                        "recovered": 21109,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Botad": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 2218,
                        "migratedother": 0,
                        "deceased": 42,
                        "recovered": 2175,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chhota Udaipur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 3395,
                        "migratedother": 0,
                        "deceased": 38,
                        "recovered": 3357,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dahod": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 9943,
                        "migratedother": 0,
                        "deceased": 38,
                        "recovered": 9903,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dang": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 864,
                        "migratedother": 0,
                        "deceased": 18,
                        "recovered": 846,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Devbhumi Dwarka": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 4172,
                        "migratedother": 0,
                        "deceased": 82,
                        "recovered": 4090,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gandhinagar": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 20740,
                        "migratedother": 0,
                        "deceased": 205,
                        "recovered": 20528,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gir Somnath": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 8555,
                        "migratedother": 0,
                        "deceased": 67,
                        "recovered": 8486,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jamnagar": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 34949,
                        "migratedother": 0,
                        "deceased": 477,
                        "recovered": 34465,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Junagadh": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 20469,
                        "migratedother": 0,
                        "deceased": 271,
                        "recovered": 20194,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Kheda": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 10422,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 10369,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kutch": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 12587,
                        "migratedother": 0,
                        "deceased": 145,
                        "recovered": 12441,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Mahisagar": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 8192,
                        "migratedother": 0,
                        "deceased": 72,
                        "recovered": 8119,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mehsana": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 24414,
                        "migratedother": 0,
                        "deceased": 177,
                        "recovered": 24232,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Morbi": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 6502,
                        "migratedother": 0,
                        "deceased": 87,
                        "recovered": 6415,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Narmada": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 5952,
                        "migratedother": 0,
                        "deceased": 15,
                        "recovered": 5937,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Navsari": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 7155,
                        "migratedother": 0,
                        "deceased": 24,
                        "recovered": 7128,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Panchmahal": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 11770,
                        "migratedother": 0,
                        "deceased": 70,
                        "recovered": 11700,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Patan": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 11624,
                        "migratedother": 0,
                        "deceased": 129,
                        "recovered": 11493,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Porbandar": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 3474,
                        "migratedother": 0,
                        "deceased": 19,
                        "recovered": 3455,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rajkot": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 57920,
                        "migratedother": 0,
                        "deceased": 723,
                        "recovered": 57183,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Sabarkantha": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 9314,
                        "migratedother": 0,
                        "deceased": 157,
                        "recovered": 9157,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Surat": {
                        "notes": "",
                        "active": 17,
                        "confirmed": 143490,
                        "migratedother": 0,
                        "deceased": 1954,
                        "recovered": 141519,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Surendranagar": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 8121,
                        "migratedother": 0,
                        "deceased": 136,
                        "recovered": 7985,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tapi": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 4438,
                        "migratedother": 0,
                        "deceased": 23,
                        "recovered": 4413,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Vadodara": {
                        "notes": "",
                        "active": 43,
                        "confirmed": 77912,
                        "migratedother": 0,
                        "deceased": 788,
                        "recovered": 77081,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Valsad": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 6244,
                        "migratedother": 0,
                        "deceased": 49,
                        "recovered": 6194,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "GJ"
            },
            "Himachal Pradesh": {
                "districtData": {
                    "Bilaspur": {
                        "notes": "",
                        "active": 152,
                        "confirmed": 13084,
                        "migratedother": 1,
                        "deceased": 79,
                        "recovered": 12852,
                        "delta": {
                            "confirmed": 19,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Chamba": {
                        "notes": "",
                        "active": 652,
                        "confirmed": 12805,
                        "migratedother": 2,
                        "deceased": 151,
                        "recovered": 12000,
                        "delta": {
                            "confirmed": 105,
                            "deceased": 0,
                            "recovered": 35
                        }
                    },
                    "Hamirpur": {
                        "notes": "",
                        "active": 262,
                        "confirmed": 14821,
                        "migratedother": 1,
                        "deceased": 257,
                        "recovered": 14301,
                        "delta": {
                            "confirmed": 35,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Kangra": {
                        "notes": "",
                        "active": 385,
                        "confirmed": 46790,
                        "migratedother": 4,
                        "deceased": 1044,
                        "recovered": 45357,
                        "delta": {
                            "confirmed": 64,
                            "deceased": 1,
                            "recovered": 6
                        }
                    },
                    "Kinnaur": {
                        "notes": "",
                        "active": 27,
                        "confirmed": 3337,
                        "migratedother": 0,
                        "deceased": 38,
                        "recovered": 3272,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kullu": {
                        "notes": "",
                        "active": 152,
                        "confirmed": 9294,
                        "migratedother": 4,
                        "deceased": 154,
                        "recovered": 8984,
                        "delta": {
                            "confirmed": 33,
                            "deceased": 0,
                            "recovered": 26
                        }
                    },
                    "Lahaul and Spiti": {
                        "notes": "",
                        "active": 53,
                        "confirmed": 2811,
                        "migratedother": 0,
                        "deceased": 18,
                        "recovered": 2740,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Mandi": {
                        "notes": "",
                        "active": 437,
                        "confirmed": 28651,
                        "migratedother": 0,
                        "deceased": 405,
                        "recovered": 27809,
                        "delta": {
                            "confirmed": 66,
                            "deceased": 0,
                            "recovered": 53
                        }
                    },
                    "Shimla": {
                        "notes": "",
                        "active": 324,
                        "confirmed": 26052,
                        "migratedother": 4,
                        "deceased": 608,
                        "recovered": 25116,
                        "delta": {
                            "confirmed": 27,
                            "deceased": 1,
                            "recovered": 8
                        }
                    },
                    "Sirmaur": {
                        "notes": "",
                        "active": 17,
                        "confirmed": 15388,
                        "migratedother": 0,
                        "deceased": 210,
                        "recovered": 15161,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Solan": {
                        "notes": "",
                        "active": 39,
                        "confirmed": 22459,
                        "migratedother": 0,
                        "deceased": 314,
                        "recovered": 22106,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Una": {
                        "notes": "",
                        "active": 56,
                        "confirmed": 13498,
                        "migratedother": 2,
                        "deceased": 245,
                        "recovered": 13195,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "HP"
            },
            "Haryana": {
                "districtData": {
                    "Foreign Evacuees": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ambala": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 30104,
                        "migratedother": 0,
                        "deceased": 509,
                        "recovered": 29583,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Bhiwani": {
                        "notes": "",
                        "active": 49,
                        "confirmed": 22394,
                        "migratedother": 0,
                        "deceased": 605,
                        "recovered": 21740,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Charkhi Dadri": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 5068,
                        "migratedother": 0,
                        "deceased": 132,
                        "recovered": 4932,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Faridabad": {
                        "notes": "",
                        "active": 24,
                        "confirmed": 99801,
                        "migratedother": 0,
                        "deceased": 716,
                        "recovered": 99061,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Fatehabad": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 17858,
                        "migratedother": 0,
                        "deceased": 463,
                        "recovered": 17382,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gurugram": {
                        "notes": "",
                        "active": 74,
                        "confirmed": 180972,
                        "migratedother": 0,
                        "deceased": 920,
                        "recovered": 179978,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Hisar": {
                        "notes": "",
                        "active": 103,
                        "confirmed": 53976,
                        "migratedother": 0,
                        "deceased": 1039,
                        "recovered": 52834,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Italians": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jhajjar": {
                        "notes": "",
                        "active": 22,
                        "confirmed": 18827,
                        "migratedother": 0,
                        "deceased": 305,
                        "recovered": 18500,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jind": {
                        "notes": "",
                        "active": 16,
                        "confirmed": 21202,
                        "migratedother": 0,
                        "deceased": 522,
                        "recovered": 20664,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kaithal": {
                        "notes": "",
                        "active": 20,
                        "confirmed": 11218,
                        "migratedother": 0,
                        "deceased": 338,
                        "recovered": 10860,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Karnal": {
                        "notes": "",
                        "active": 40,
                        "confirmed": 39999,
                        "migratedother": 0,
                        "deceased": 546,
                        "recovered": 39413,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kurukshetra": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 22114,
                        "migratedother": 0,
                        "deceased": 356,
                        "recovered": 21751,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Mahendragarh": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 21687,
                        "migratedother": 0,
                        "deceased": 153,
                        "recovered": 21533,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nuh": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 5010,
                        "migratedother": 0,
                        "deceased": 120,
                        "recovered": 4889,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Palwal": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 10981,
                        "migratedother": 0,
                        "deceased": 153,
                        "recovered": 10825,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Panchkula": {
                        "notes": "",
                        "active": 25,
                        "confirmed": 30656,
                        "migratedother": 0,
                        "deceased": 374,
                        "recovered": 30257,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Panipat": {
                        "notes": "",
                        "active": 91,
                        "confirmed": 31135,
                        "migratedother": 0,
                        "deceased": 565,
                        "recovered": 30479,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Rewari": {
                        "notes": "",
                        "active": 20,
                        "confirmed": 20304,
                        "migratedother": 0,
                        "deceased": 209,
                        "recovered": 20075,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rohtak": {
                        "notes": "",
                        "active": 88,
                        "confirmed": 25876,
                        "migratedother": 0,
                        "deceased": 499,
                        "recovered": 25289,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sirsa": {
                        "notes": "",
                        "active": 51,
                        "confirmed": 29256,
                        "migratedother": 0,
                        "deceased": 467,
                        "recovered": 28738,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sonipat": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 47126,
                        "migratedother": 0,
                        "deceased": 254,
                        "recovered": 46870,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Yamunanagar": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 24566,
                        "migratedother": 0,
                        "deceased": 408,
                        "recovered": 24154,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "HR"
            },
            "Jharkhand": {
                "districtData": {
                    "Bokaro": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 19413,
                        "migratedother": 0,
                        "deceased": 286,
                        "recovered": 19123,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Chatra": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 6025,
                        "migratedother": 0,
                        "deceased": 53,
                        "recovered": 5971,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Deoghar": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 10801,
                        "migratedother": 0,
                        "deceased": 113,
                        "recovered": 10677,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Dhanbad": {
                        "notes": "",
                        "active": 24,
                        "confirmed": 16503,
                        "migratedother": 0,
                        "deceased": 379,
                        "recovered": 16100,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Dumka": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 4631,
                        "migratedother": 0,
                        "deceased": 47,
                        "recovered": 4583,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "East Singhbhum": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 51780,
                        "migratedother": 0,
                        "deceased": 1043,
                        "recovered": 50726,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Garhwa": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 6884,
                        "migratedother": 0,
                        "deceased": 94,
                        "recovered": 6789,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Giridih": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 8959,
                        "migratedother": 0,
                        "deceased": 130,
                        "recovered": 8827,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Godda": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 5836,
                        "migratedother": 0,
                        "deceased": 87,
                        "recovered": 5746,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gumla": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 9893,
                        "migratedother": 0,
                        "deceased": 38,
                        "recovered": 9854,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Hazaribagh": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 19581,
                        "migratedother": 0,
                        "deceased": 186,
                        "recovered": 19392,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jamtara": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 5555,
                        "migratedother": 0,
                        "deceased": 60,
                        "recovered": 5492,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Khunti": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 7783,
                        "migratedother": 0,
                        "deceased": 96,
                        "recovered": 7677,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Koderma": {
                        "notes": "",
                        "active": 18,
                        "confirmed": 12871,
                        "migratedother": 0,
                        "deceased": 136,
                        "recovered": 12717,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Latehar": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 7863,
                        "migratedother": 0,
                        "deceased": 57,
                        "recovered": 7802,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Lohardaga": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 6689,
                        "migratedother": 0,
                        "deceased": 88,
                        "recovered": 6595,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Pakur": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 2550,
                        "migratedother": 0,
                        "deceased": 12,
                        "recovered": 2531,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Palamu": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 12289,
                        "migratedother": 0,
                        "deceased": 110,
                        "recovered": 12179,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ramgarh": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 13896,
                        "migratedother": 0,
                        "deceased": 196,
                        "recovered": 13689,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Ranchi": {
                        "notes": "",
                        "active": 62,
                        "confirmed": 85440,
                        "migratedother": 0,
                        "deceased": 1585,
                        "recovered": 83793,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Sahibganj": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 4816,
                        "migratedother": 0,
                        "deceased": 42,
                        "recovered": 4771,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Saraikela-Kharsawan": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 7204,
                        "migratedother": 0,
                        "deceased": 67,
                        "recovered": 7133,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Simdega": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 7191,
                        "migratedother": 0,
                        "deceased": 92,
                        "recovered": 7094,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "West Singhbhum": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 13001,
                        "migratedother": 0,
                        "deceased": 133,
                        "recovered": 12867,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    }
                },
                "statecode": "JH"
            },
            "Jammu and Kashmir": {
                "districtData": {
                    "Anantnag": {
                        "notes": "",
                        "active": 24,
                        "confirmed": 16346,
                        "migratedother": 0,
                        "deceased": 205,
                        "recovered": 16117,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Bandipora": {
                        "notes": "",
                        "active": 57,
                        "confirmed": 9531,
                        "migratedother": 0,
                        "deceased": 100,
                        "recovered": 9374,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Baramulla": {
                        "notes": "",
                        "active": 88,
                        "confirmed": 23736,
                        "migratedother": 0,
                        "deceased": 282,
                        "recovered": 23366,
                        "delta": {
                            "confirmed": 11,
                            "deceased": 0,
                            "recovered": 25
                        }
                    },
                    "Budgam": {
                        "notes": "",
                        "active": 73,
                        "confirmed": 22984,
                        "migratedother": 0,
                        "deceased": 206,
                        "recovered": 22705,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 9
                        }
                    },
                    "Doda": {
                        "notes": "",
                        "active": 111,
                        "confirmed": 7374,
                        "migratedother": 0,
                        "deceased": 128,
                        "recovered": 7135,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 11
                        }
                    },
                    "Ganderbal": {
                        "notes": "",
                        "active": 69,
                        "confirmed": 9989,
                        "migratedother": 0,
                        "deceased": 78,
                        "recovered": 9842,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Jammu": {
                        "notes": "",
                        "active": 136,
                        "confirmed": 52877,
                        "migratedother": 0,
                        "deceased": 1140,
                        "recovered": 51601,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Kathua": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 9268,
                        "migratedother": 0,
                        "deceased": 151,
                        "recovered": 9113,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Kishtwar": {
                        "notes": "",
                        "active": 50,
                        "confirmed": 4695,
                        "migratedother": 0,
                        "deceased": 44,
                        "recovered": 4601,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Kulgam": {
                        "notes": "",
                        "active": 32,
                        "confirmed": 11312,
                        "migratedother": 0,
                        "deceased": 117,
                        "recovered": 11163,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Kupwara": {
                        "notes": "",
                        "active": 47,
                        "confirmed": 14137,
                        "migratedother": 0,
                        "deceased": 165,
                        "recovered": 13925,
                        "delta": {
                            "confirmed": 20,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Mirpur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Muzaffarabad": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pulwama": {
                        "notes": "",
                        "active": 47,
                        "confirmed": 15240,
                        "migratedother": 0,
                        "deceased": 194,
                        "recovered": 14999,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Punch": {
                        "notes": "",
                        "active": 31,
                        "confirmed": 6285,
                        "migratedother": 0,
                        "deceased": 97,
                        "recovered": 6157,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Rajouri": {
                        "notes": "",
                        "active": 71,
                        "confirmed": 11006,
                        "migratedother": 0,
                        "deceased": 228,
                        "recovered": 10707,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Ramban": {
                        "notes": "",
                        "active": 18,
                        "confirmed": 5980,
                        "migratedother": 0,
                        "deceased": 67,
                        "recovered": 5895,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 1,
                            "recovered": 4
                        }
                    },
                    "Reasi": {
                        "notes": "",
                        "active": 68,
                        "confirmed": 6336,
                        "migratedother": 0,
                        "deceased": 43,
                        "recovered": 6225,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Samba": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 7127,
                        "migratedother": 0,
                        "deceased": 119,
                        "recovered": 7002,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shopiyan": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 5588,
                        "migratedother": 0,
                        "deceased": 58,
                        "recovered": 5526,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Srinagar": {
                        "notes": "",
                        "active": 309,
                        "confirmed": 71719,
                        "migratedother": 0,
                        "deceased": 834,
                        "recovered": 70576,
                        "delta": {
                            "confirmed": 27,
                            "deceased": 0,
                            "recovered": 16
                        }
                    },
                    "Udhampur": {
                        "notes": "",
                        "active": 52,
                        "confirmed": 11355,
                        "migratedother": 0,
                        "deceased": 137,
                        "recovered": 11166,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    }
                },
                "statecode": "JK"
            },
            "Karnataka": {
                "districtData": {
                    "Bagalkote": {
                        "notes": "",
                        "active": 39,
                        "confirmed": 35121,
                        "migratedother": 0,
                        "deceased": 327,
                        "recovered": 34755,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Ballari": {
                        "notes": "",
                        "active": 217,
                        "confirmed": 97504,
                        "migratedother": 0,
                        "deceased": 1685,
                        "recovered": 95602,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Belagavi": {
                        "notes": "",
                        "active": 390,
                        "confirmed": 78627,
                        "migratedother": 0,
                        "deceased": 876,
                        "recovered": 77361,
                        "delta": {
                            "confirmed": 47,
                            "deceased": 3,
                            "recovered": 39
                        }
                    },
                    "Bengaluru Rural": {
                        "notes": "",
                        "active": 336,
                        "confirmed": 61199,
                        "migratedother": 0,
                        "deceased": 861,
                        "recovered": 60002,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 1,
                            "recovered": 17
                        }
                    },
                    "Bengaluru Urban": {
                        "notes": "",
                        "active": 8290,
                        "confirmed": 1231474,
                        "migratedother": 1,
                        "deceased": 15923,
                        "recovered": 1207260,
                        "delta": {
                            "confirmed": 377,
                            "deceased": 5,
                            "recovered": 280
                        }
                    },
                    "Bidar": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 24284,
                        "migratedother": 4,
                        "deceased": 396,
                        "recovered": 23873,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Chamarajanagara": {
                        "notes": "",
                        "active": 292,
                        "confirmed": 32577,
                        "migratedother": 11,
                        "deceased": 485,
                        "recovered": 31789,
                        "delta": {
                            "confirmed": 15,
                            "deceased": 0,
                            "recovered": 15
                        }
                    },
                    "Chikkaballapura": {
                        "notes": "",
                        "active": 92,
                        "confirmed": 43776,
                        "migratedother": 1,
                        "deceased": 423,
                        "recovered": 43260,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 30
                        }
                    },
                    "Chikkamagaluru": {
                        "notes": "",
                        "active": 1059,
                        "confirmed": 49033,
                        "migratedother": 0,
                        "deceased": 377,
                        "recovered": 47597,
                        "delta": {
                            "confirmed": 65,
                            "deceased": 0,
                            "recovered": 30
                        }
                    },
                    "Chitradurga": {
                        "notes": "",
                        "active": 469,
                        "confirmed": 36095,
                        "migratedother": 0,
                        "deceased": 192,
                        "recovered": 35434,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 2,
                            "recovered": 52
                        }
                    },
                    "Dakshina Kannada": {
                        "notes": "",
                        "active": 3479,
                        "confirmed": 104257,
                        "migratedother": 5,
                        "deceased": 1477,
                        "recovered": 99296,
                        "delta": {
                            "confirmed": 422,
                            "deceased": 5,
                            "recovered": 270
                        }
                    },
                    "Davanagere": {
                        "notes": "",
                        "active": 192,
                        "confirmed": 50500,
                        "migratedother": 0,
                        "deceased": 590,
                        "recovered": 49718,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 14
                        }
                    },
                    "Dharwad": {
                        "notes": "",
                        "active": 133,
                        "confirmed": 60600,
                        "migratedother": 2,
                        "deceased": 1289,
                        "recovered": 59176,
                        "delta": {
                            "confirmed": 17,
                            "deceased": 0,
                            "recovered": 16
                        }
                    },
                    "Gadag": {
                        "notes": "",
                        "active": 22,
                        "confirmed": 26004,
                        "migratedother": 0,
                        "deceased": 316,
                        "recovered": 25666,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Hassan": {
                        "notes": "",
                        "active": 1497,
                        "confirmed": 107826,
                        "migratedother": 2,
                        "deceased": 1193,
                        "recovered": 105134,
                        "delta": {
                            "confirmed": 175,
                            "deceased": 3,
                            "recovered": 127
                        }
                    },
                    "Haveri": {
                        "notes": "",
                        "active": 27,
                        "confirmed": 21884,
                        "migratedother": 0,
                        "deceased": 631,
                        "recovered": 21226,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kalaburagi": {
                        "notes": "",
                        "active": 92,
                        "confirmed": 61687,
                        "migratedother": 0,
                        "deceased": 818,
                        "recovered": 60777,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Kodagu": {
                        "notes": "",
                        "active": 727,
                        "confirmed": 33974,
                        "migratedother": 0,
                        "deceased": 301,
                        "recovered": 32946,
                        "delta": {
                            "confirmed": 71,
                            "deceased": 2,
                            "recovered": 83
                        }
                    },
                    "Kolar": {
                        "notes": "",
                        "active": 262,
                        "confirmed": 45901,
                        "migratedother": 0,
                        "deceased": 600,
                        "recovered": 45039,
                        "delta": {
                            "confirmed": 36,
                            "deceased": 3,
                            "recovered": 35
                        }
                    },
                    "Koppal": {
                        "notes": "",
                        "active": 66,
                        "confirmed": 35117,
                        "migratedother": 0,
                        "deceased": 518,
                        "recovered": 34533,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Mandya": {
                        "notes": "",
                        "active": 405,
                        "confirmed": 72492,
                        "migratedother": 0,
                        "deceased": 630,
                        "recovered": 71457,
                        "delta": {
                            "confirmed": 35,
                            "deceased": 2,
                            "recovered": 28
                        }
                    },
                    "Mysuru": {
                        "notes": "",
                        "active": 1174,
                        "confirmed": 174199,
                        "migratedother": 0,
                        "deceased": 2331,
                        "recovered": 170694,
                        "delta": {
                            "confirmed": 118,
                            "deceased": 3,
                            "recovered": 149
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 36,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 33,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Raichur": {
                        "notes": "",
                        "active": 30,
                        "confirmed": 39900,
                        "migratedother": 0,
                        "deceased": 329,
                        "recovered": 39541,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Ramanagara": {
                        "notes": "",
                        "active": 93,
                        "confirmed": 24050,
                        "migratedother": 0,
                        "deceased": 311,
                        "recovered": 23646,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Shivamogga": {
                        "notes": "",
                        "active": 558,
                        "confirmed": 67431,
                        "migratedother": 0,
                        "deceased": 1063,
                        "recovered": 65810,
                        "delta": {
                            "confirmed": 47,
                            "deceased": 1,
                            "recovered": 121
                        }
                    },
                    "Tumakuru": {
                        "notes": "",
                        "active": 882,
                        "confirmed": 118431,
                        "migratedother": 0,
                        "deceased": 1080,
                        "recovered": 116469,
                        "delta": {
                            "confirmed": 88,
                            "deceased": 0,
                            "recovered": 54
                        }
                    },
                    "Udupi": {
                        "notes": "",
                        "active": 1427,
                        "confirmed": 71170,
                        "migratedother": 0,
                        "deceased": 434,
                        "recovered": 69309,
                        "delta": {
                            "confirmed": 130,
                            "deceased": 1,
                            "recovered": 166
                        }
                    },
                    "Uttara Kannada": {
                        "notes": "",
                        "active": 541,
                        "confirmed": 54051,
                        "migratedother": 0,
                        "deceased": 727,
                        "recovered": 52783,
                        "delta": {
                            "confirmed": 79,
                            "deceased": 2,
                            "recovered": 51
                        }
                    },
                    "Vijayapura": {
                        "notes": "",
                        "active": 35,
                        "confirmed": 36174,
                        "migratedother": 0,
                        "deceased": 489,
                        "recovered": 35650,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Yadgir": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 27501,
                        "migratedother": 0,
                        "deceased": 206,
                        "recovered": 27281,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 1
                        }
                    }
                },
                "statecode": "KA"
            },
            "Kerala": {
                "districtData": {
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Alappuzha": {
                        "notes": "",
                        "active": 8265,
                        "confirmed": 237133,
                        "migratedother": 40,
                        "deceased": 1150,
                        "recovered": 227678,
                        "delta": {
                            "confirmed": 1440,
                            "deceased": 5,
                            "recovered": 1073
                        }
                    },
                    "Ernakulam": {
                        "notes": "",
                        "active": 26921,
                        "confirmed": 430396,
                        "migratedother": 69,
                        "deceased": 1830,
                        "recovered": 401576,
                        "delta": {
                            "confirmed": 2856,
                            "deceased": 12,
                            "recovered": 2024
                        }
                    },
                    "Idukki": {
                        "notes": "",
                        "active": 6218,
                        "confirmed": 96572,
                        "migratedother": 8,
                        "deceased": 238,
                        "recovered": 90108,
                        "delta": {
                            "confirmed": 637,
                            "deceased": 2,
                            "recovered": 353
                        }
                    },
                    "Kannur": {
                        "notes": "",
                        "active": 8847,
                        "confirmed": 199236,
                        "migratedother": 51,
                        "deceased": 1147,
                        "recovered": 189191,
                        "delta": {
                            "confirmed": 1194,
                            "deceased": 1,
                            "recovered": 1323
                        }
                    },
                    "Kasaragod": {
                        "notes": "",
                        "active": 8732,
                        "confirmed": 114698,
                        "migratedother": 18,
                        "deceased": 382,
                        "recovered": 105566,
                        "delta": {
                            "confirmed": 562,
                            "deceased": 1,
                            "recovered": 132
                        }
                    },
                    "Kollam": {
                        "notes": "",
                        "active": 2412,
                        "confirmed": 284264,
                        "migratedother": 59,
                        "deceased": 1389,
                        "recovered": 280404,
                        "delta": {
                            "confirmed": 1633,
                            "deceased": 14,
                            "recovered": 1165
                        }
                    },
                    "Kottayam": {
                        "notes": "",
                        "active": 7989,
                        "confirmed": 231995,
                        "migratedother": 14,
                        "deceased": 762,
                        "recovered": 223230,
                        "delta": {
                            "confirmed": 1227,
                            "deceased": 3,
                            "recovered": 1301
                        }
                    },
                    "Kozhikode": {
                        "notes": "",
                        "active": 23271,
                        "confirmed": 387573,
                        "migratedother": 43,
                        "deceased": 1869,
                        "recovered": 362390,
                        "delta": {
                            "confirmed": 2789,
                            "deceased": 10,
                            "recovered": 2098
                        }
                    },
                    "Malappuram": {
                        "notes": "",
                        "active": 28759,
                        "confirmed": 440734,
                        "migratedother": 30,
                        "deceased": 1508,
                        "recovered": 410437,
                        "delta": {
                            "confirmed": 3109,
                            "deceased": 13,
                            "recovered": 2940
                        }
                    },
                    "Palakkad": {
                        "notes": "",
                        "active": 17683,
                        "confirmed": 269048,
                        "migratedother": 22,
                        "deceased": 1652,
                        "recovered": 249691,
                        "delta": {
                            "confirmed": 2414,
                            "deceased": 19,
                            "recovered": 2177
                        }
                    },
                    "Pathanamthitta": {
                        "notes": "",
                        "active": 8298,
                        "confirmed": 136773,
                        "migratedother": 11,
                        "deceased": 554,
                        "recovered": 127910,
                        "delta": {
                            "confirmed": 696,
                            "deceased": 5,
                            "recovered": 532
                        }
                    },
                    "Thiruvananthapuram": {
                        "notes": "",
                        "active": 9386,
                        "confirmed": 343093,
                        "migratedother": 115,
                        "deceased": 3376,
                        "recovered": 330216,
                        "delta": {
                            "confirmed": 1255,
                            "deceased": 11,
                            "recovered": 1169
                        }
                    },
                    "Thrissur": {
                        "notes": "",
                        "active": 11239,
                        "confirmed": 355009,
                        "migratedother": 26,
                        "deceased": 1965,
                        "recovered": 341779,
                        "delta": {
                            "confirmed": 3124,
                            "deceased": 19,
                            "recovered": 2602
                        }
                    },
                    "Wayanad": {
                        "notes": "",
                        "active": 7938,
                        "confirmed": 83669,
                        "migratedother": 14,
                        "deceased": 298,
                        "recovered": 75419,
                        "delta": {
                            "confirmed": 564,
                            "deceased": 1,
                            "recovered": 522
                        }
                    }
                },
                "statecode": "KL"
            },
            "Ladakh": {
                "districtData": {
                    "Kargil": {
                        "notes": "",
                        "active": 18,
                        "confirmed": 3572,
                        "migratedother": 0,
                        "deceased": 58,
                        "recovered": 3496,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Leh": {
                        "notes": "",
                        "active": 52,
                        "confirmed": 16835,
                        "migratedother": 0,
                        "deceased": 149,
                        "recovered": 16634,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "LA"
            },
            "Lakshadweep": {
                "districtData": {
                    "Lakshadweep": {
                        "notes": "",
                        "active": 43,
                        "confirmed": 10268,
                        "migratedother": 40,
                        "deceased": 50,
                        "recovered": 10135,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 10
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -1,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "LD"
            },
            "Maharashtra": {
                "districtData": {
                    "Ahmednagar": {
                        "notes": "",
                        "active": 5231,
                        "confirmed": 294758,
                        "migratedother": 1,
                        "deceased": 6304,
                        "recovered": 283222,
                        "delta": {
                            "confirmed": 834,
                            "deceased": 19,
                            "recovered": 1776
                        }
                    },
                    "Akola": {
                        "notes": "",
                        "active": 38,
                        "confirmed": 58638,
                        "migratedother": 4,
                        "deceased": 1420,
                        "recovered": 57176,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Amravati": {
                        "notes": "",
                        "active": 76,
                        "confirmed": 96012,
                        "migratedother": 2,
                        "deceased": 1637,
                        "recovered": 94297,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 1,
                            "recovered": 3
                        }
                    },
                    "Aurangabad": {
                        "notes": "",
                        "active": 687,
                        "confirmed": 154499,
                        "migratedother": 14,
                        "deceased": 4198,
                        "recovered": 149600,
                        "delta": {
                            "confirmed": 23,
                            "deceased": 1,
                            "recovered": 4
                        }
                    },
                    "Beed": {
                        "notes": "",
                        "active": 1678,
                        "confirmed": 99459,
                        "migratedother": 7,
                        "deceased": 2637,
                        "recovered": 95137,
                        "delta": {
                            "confirmed": 113,
                            "deceased": 4,
                            "recovered": 168
                        }
                    },
                    "Bhandara": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 60038,
                        "migratedother": 10,
                        "deceased": 1113,
                        "recovered": 58915,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Buldhana": {
                        "notes": "",
                        "active": 77,
                        "confirmed": 84828,
                        "migratedother": 6,
                        "deceased": 765,
                        "recovered": 83980,
                        "delta": {
                            "confirmed": 18,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Chandrapur": {
                        "notes": "",
                        "active": 75,
                        "confirmed": 88688,
                        "migratedother": 4,
                        "deceased": 1606,
                        "recovered": 87003,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dhule": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 46270,
                        "migratedother": 12,
                        "deceased": 652,
                        "recovered": 45606,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gadchiroli": {
                        "notes": "",
                        "active": 18,
                        "confirmed": 30288,
                        "migratedother": 32,
                        "deceased": 672,
                        "recovered": 29566,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 13
                        }
                    },
                    "Gondia": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 40534,
                        "migratedother": 7,
                        "deceased": 568,
                        "recovered": 39957,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hingoli": {
                        "notes": "",
                        "active": 78,
                        "confirmed": 18419,
                        "migratedother": 1,
                        "deceased": 498,
                        "recovered": 17842,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Jalgaon": {
                        "notes": "",
                        "active": 320,
                        "confirmed": 139800,
                        "migratedother": 32,
                        "deceased": 2662,
                        "recovered": 136786,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jalna": {
                        "notes": "",
                        "active": 175,
                        "confirmed": 60314,
                        "migratedother": 1,
                        "deceased": 1199,
                        "recovered": 58939,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kolhapur": {
                        "notes": "",
                        "active": 4427,
                        "confirmed": 199490,
                        "migratedother": 5,
                        "deceased": 5647,
                        "recovered": 189411,
                        "delta": {
                            "confirmed": 337,
                            "deceased": 15,
                            "recovered": 474
                        }
                    },
                    "Latur": {
                        "notes": "",
                        "active": 499,
                        "confirmed": 91166,
                        "migratedother": 6,
                        "deceased": 2406,
                        "recovered": 88255,
                        "delta": {
                            "confirmed": 35,
                            "deceased": 0,
                            "recovered": 44
                        }
                    },
                    "Mumbai": {
                        "notes": "[Sep 9]After reconciling COVID-19 cases in Mumbai, owing to the removal of duplicates and change of addresses as per the original residence, 239 cases have been removed from the progressive figures.",
                        "active": 4212,
                        "confirmed": 738239,
                        "migratedother": 2409,
                        "deceased": 15968,
                        "recovered": 715650,
                        "delta": {
                            "confirmed": 285,
                            "deceased": 9,
                            "recovered": 560
                        }
                    },
                    "Mumbai Suburban": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nagpur": {
                        "notes": "District administration provides number of persons tested instead of the number of samples tested.",
                        "active": 264,
                        "confirmed": 493063,
                        "migratedother": 71,
                        "deceased": 9137,
                        "recovered": 483591,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nanded": {
                        "notes": "Number of active cases differs in the state bulletin and district bulletin. We follow the state bulletin.",
                        "active": 57,
                        "confirmed": 90649,
                        "migratedother": 6,
                        "deceased": 2661,
                        "recovered": 87925,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Nandurbar": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 39968,
                        "migratedother": 3,
                        "deceased": 948,
                        "recovered": 39013,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nashik": {
                        "notes": "Number of active cases differs in the state bulletin and district bulletin. We follow the state bulletin.",
                        "active": 839,
                        "confirmed": 403658,
                        "migratedother": 1,
                        "deceased": 8561,
                        "recovered": 394257,
                        "delta": {
                            "confirmed": 102,
                            "deceased": 5,
                            "recovered": 49
                        }
                    },
                    "Osmanabad": {
                        "notes": "",
                        "active": 1005,
                        "confirmed": 64970,
                        "migratedother": 111,
                        "deceased": 1833,
                        "recovered": 62021,
                        "delta": {
                            "confirmed": 101,
                            "deceased": 2,
                            "recovered": 135
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 28,
                        "confirmed": 146,
                        "migratedother": 2,
                        "deceased": 116,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Palghar": {
                        "notes": "",
                        "active": 686,
                        "confirmed": 133835,
                        "migratedother": 14,
                        "deceased": 3220,
                        "recovered": 129915,
                        "delta": {
                            "confirmed": 52,
                            "deceased": 3,
                            "recovered": 0
                        }
                    },
                    "Parbhani": {
                        "notes": "",
                        "active": 248,
                        "confirmed": 52279,
                        "migratedother": 18,
                        "deceased": 1220,
                        "recovered": 50793,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 11
                        }
                    },
                    "Pune": {
                        "notes": "Number of active cases differs in the state bulletin and district bulletin. We follow the state bulletin.",
                        "active": 14419,
                        "confirmed": 1099851,
                        "migratedother": 306,
                        "deceased": 18679,
                        "recovered": 1066447,
                        "delta": {
                            "confirmed": 1146,
                            "deceased": 9,
                            "recovered": 610
                        }
                    },
                    "Raigad": {
                        "notes": "Number of active cases differs in the state bulletin and district bulletin. We follow the state bulletin.",
                        "active": 1881,
                        "confirmed": 185702,
                        "migratedother": 6,
                        "deceased": 4266,
                        "recovered": 179549,
                        "delta": {
                            "confirmed": 191,
                            "deceased": 4,
                            "recovered": 180
                        }
                    },
                    "Ratnagiri": {
                        "notes": "",
                        "active": 1751,
                        "confirmed": 73420,
                        "migratedother": 4,
                        "deceased": 2143,
                        "recovered": 69522,
                        "delta": {
                            "confirmed": 155,
                            "deceased": 3,
                            "recovered": 137
                        }
                    },
                    "Sangli": {
                        "notes": "",
                        "active": 6964,
                        "confirmed": 192215,
                        "migratedother": 9,
                        "deceased": 5217,
                        "recovered": 180025,
                        "delta": {
                            "confirmed": 568,
                            "deceased": 12,
                            "recovered": 889
                        }
                    },
                    "Satara": {
                        "notes": "",
                        "active": 6239,
                        "confirmed": 226151,
                        "migratedother": 27,
                        "deceased": 5471,
                        "recovered": 214414,
                        "delta": {
                            "confirmed": 594,
                            "deceased": 28,
                            "recovered": 796
                        }
                    },
                    "Sindhudurg": {
                        "notes": "",
                        "active": 1440,
                        "confirmed": 49379,
                        "migratedother": 15,
                        "deceased": 1259,
                        "recovered": 46665,
                        "delta": {
                            "confirmed": 83,
                            "deceased": 5,
                            "recovered": 105
                        }
                    },
                    "Solapur": {
                        "notes": "",
                        "active": 5207,
                        "confirmed": 194066,
                        "migratedother": 96,
                        "deceased": 4986,
                        "recovered": 183777,
                        "delta": {
                            "confirmed": 602,
                            "deceased": 32,
                            "recovered": 564
                        }
                    },
                    "Thane": {
                        "notes": "",
                        "active": 5901,
                        "confirmed": 592025,
                        "migratedother": 34,
                        "deceased": 11092,
                        "recovered": 574998,
                        "delta": {
                            "confirmed": 263,
                            "deceased": 9,
                            "recovered": 423
                        }
                    },
                    "Wardha": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 58342,
                        "migratedother": 165,
                        "deceased": 1204,
                        "recovered": 56962,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Washim": {
                        "notes": "",
                        "active": 20,
                        "confirmed": 41623,
                        "migratedother": 3,
                        "deceased": 617,
                        "recovered": 40983,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Yavatmal": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 76220,
                        "migratedother": 4,
                        "deceased": 1782,
                        "recovered": 74421,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "MH"
            },
            "Meghalaya": {
                "districtData": {
                    "East Garo Hills": {
                        "notes": "",
                        "active": 56,
                        "confirmed": 1761,
                        "migratedother": 0,
                        "deceased": 9,
                        "recovered": 1696,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "East Jaintia Hills": {
                        "notes": "",
                        "active": 63,
                        "confirmed": 2228,
                        "migratedother": 0,
                        "deceased": 28,
                        "recovered": 2137,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "East Khasi Hills": {
                        "notes": "",
                        "active": 1981,
                        "confirmed": 34271,
                        "migratedother": 0,
                        "deceased": 837,
                        "recovered": 31453,
                        "delta": {
                            "confirmed": 256,
                            "deceased": 7,
                            "recovered": 76
                        }
                    },
                    "North Garo Hills": {
                        "notes": "",
                        "active": 54,
                        "confirmed": 1622,
                        "migratedother": 0,
                        "deceased": 8,
                        "recovered": 1560,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 12
                        }
                    },
                    "Ribhoi": {
                        "notes": "",
                        "active": 437,
                        "confirmed": 8344,
                        "migratedother": 0,
                        "deceased": 66,
                        "recovered": 7841,
                        "delta": {
                            "confirmed": 28,
                            "deceased": 0,
                            "recovered": 56
                        }
                    },
                    "South Garo Hills": {
                        "notes": "",
                        "active": 45,
                        "confirmed": 1154,
                        "migratedother": 0,
                        "deceased": 11,
                        "recovered": 1098,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "South West Garo Hills": {
                        "notes": "",
                        "active": 48,
                        "confirmed": 1792,
                        "migratedother": 0,
                        "deceased": 15,
                        "recovered": 1729,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "South West Khasi Hills": {
                        "notes": "",
                        "active": 219,
                        "confirmed": 1951,
                        "migratedother": 0,
                        "deceased": 12,
                        "recovered": 1720,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 0,
                            "recovered": 14
                        }
                    },
                    "West Garo Hills": {
                        "notes": "",
                        "active": 524,
                        "confirmed": 8461,
                        "migratedother": 0,
                        "deceased": 65,
                        "recovered": 7872,
                        "delta": {
                            "confirmed": 40,
                            "deceased": 0,
                            "recovered": 82
                        }
                    },
                    "West Jaintia Hills": {
                        "notes": "",
                        "active": 443,
                        "confirmed": 5599,
                        "migratedother": 0,
                        "deceased": 105,
                        "recovered": 5051,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 1,
                            "recovered": 39
                        }
                    },
                    "West Khasi Hills": {
                        "notes": "",
                        "active": 626,
                        "confirmed": 3049,
                        "migratedother": 0,
                        "deceased": 39,
                        "recovered": 2384,
                        "delta": {
                            "confirmed": 67,
                            "deceased": 2,
                            "recovered": 87
                        }
                    }
                },
                "statecode": "ML"
            },
            "Manipur": {
                "districtData": {
                    "CAPF Personnel": {
                        "notes": "",
                        "active": 1568,
                        "confirmed": 3251,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 1681,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bishnupur": {
                        "notes": "",
                        "active": 7685,
                        "confirmed": 7897,
                        "migratedother": 0,
                        "deceased": 154,
                        "recovered": 58,
                        "delta": {
                            "confirmed": 74,
                            "deceased": 3,
                            "recovered": 0
                        }
                    },
                    "Chandel": {
                        "notes": "",
                        "active": 1684,
                        "confirmed": 1718,
                        "migratedother": 0,
                        "deceased": 30,
                        "recovered": 4,
                        "delta": {
                            "confirmed": 20,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Churachandpur": {
                        "notes": "",
                        "active": 8181,
                        "confirmed": 8377,
                        "migratedother": 0,
                        "deceased": 138,
                        "recovered": 58,
                        "delta": {
                            "confirmed": 46,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Imphal East": {
                        "notes": "",
                        "active": 22367,
                        "confirmed": 22898,
                        "migratedother": 0,
                        "deceased": 381,
                        "recovered": 150,
                        "delta": {
                            "confirmed": 89,
                            "deceased": 3,
                            "recovered": 0
                        }
                    },
                    "Imphal West": {
                        "notes": "",
                        "active": 33914,
                        "confirmed": 34490,
                        "migratedother": 0,
                        "deceased": 524,
                        "recovered": 52,
                        "delta": {
                            "confirmed": 267,
                            "deceased": 3,
                            "recovered": 0
                        }
                    },
                    "Jiribam": {
                        "notes": "",
                        "active": 865,
                        "confirmed": 873,
                        "migratedother": 0,
                        "deceased": 6,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kakching": {
                        "notes": "",
                        "active": 5612,
                        "confirmed": 5740,
                        "migratedother": 0,
                        "deceased": 101,
                        "recovered": 27,
                        "delta": {
                            "confirmed": 24,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kamjong": {
                        "notes": "",
                        "active": 520,
                        "confirmed": 540,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 17,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kangpokpi": {
                        "notes": "",
                        "active": 1828,
                        "confirmed": 1897,
                        "migratedother": 0,
                        "deceased": 50,
                        "recovered": 19,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Noney": {
                        "notes": "",
                        "active": 816,
                        "confirmed": 838,
                        "migratedother": 0,
                        "deceased": 4,
                        "recovered": 18,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pherzawl": {
                        "notes": "",
                        "active": 255,
                        "confirmed": 270,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 15,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Senapati": {
                        "notes": "",
                        "active": 1635,
                        "confirmed": 1662,
                        "migratedother": 0,
                        "deceased": 6,
                        "recovered": 21,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tamenglong": {
                        "notes": "",
                        "active": 2740,
                        "confirmed": 2783,
                        "migratedother": 0,
                        "deceased": 11,
                        "recovered": 32,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tengnoupal": {
                        "notes": "",
                        "active": 821,
                        "confirmed": 844,
                        "migratedother": 0,
                        "deceased": 10,
                        "recovered": 13,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Thoubal": {
                        "notes": "",
                        "active": 8369,
                        "confirmed": 8532,
                        "migratedother": 0,
                        "deceased": 140,
                        "recovered": 23,
                        "delta": {
                            "confirmed": 29,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ukhrul": {
                        "notes": "",
                        "active": 1533,
                        "confirmed": 1572,
                        "migratedother": 0,
                        "deceased": 21,
                        "recovered": 18,
                        "delta": {
                            "confirmed": 20,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -93536,
                        "confirmed": 1848,
                        "migratedother": 0,
                        "deceased": 93,
                        "recovered": 95291,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "MN"
            },
            "Madhya Pradesh": {
                "districtData": {
                    "Agar Malwa": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 3303,
                        "migratedother": 0,
                        "deceased": 68,
                        "recovered": 3235,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Alirajpur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 3501,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 3453,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Anuppur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 9229,
                        "migratedother": 0,
                        "deceased": 89,
                        "recovered": 9140,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ashoknagar": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 3670,
                        "migratedother": 0,
                        "deceased": 57,
                        "recovered": 3613,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Balaghat": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 9090,
                        "migratedother": 0,
                        "deceased": 64,
                        "recovered": 9017,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Barwani": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 8363,
                        "migratedother": 0,
                        "deceased": 90,
                        "recovered": 8267,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Betul": {
                        "notes": "",
                        "active": 32,
                        "confirmed": 12899,
                        "migratedother": 0,
                        "deceased": 277,
                        "recovered": 12590,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bhind": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 2994,
                        "migratedother": 0,
                        "deceased": 32,
                        "recovered": 2960,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bhopal": {
                        "notes": "",
                        "active": 230,
                        "confirmed": 123323,
                        "migratedother": 0,
                        "deceased": 972,
                        "recovered": 122121,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Burhanpur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 2568,
                        "migratedother": 0,
                        "deceased": 39,
                        "recovered": 2529,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chhatarpur": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 7607,
                        "migratedother": 0,
                        "deceased": 91,
                        "recovered": 7506,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chhindwara": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 6732,
                        "migratedother": 0,
                        "deceased": 120,
                        "recovered": 6612,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Damoh": {
                        "notes": "",
                        "active": 93,
                        "confirmed": 8120,
                        "migratedother": 0,
                        "deceased": 186,
                        "recovered": 7841,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Datia": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 6958,
                        "migratedother": 0,
                        "deceased": 78,
                        "recovered": 6874,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dewas": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 7723,
                        "migratedother": 0,
                        "deceased": 51,
                        "recovered": 7672,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dhar": {
                        "notes": "",
                        "active": 15,
                        "confirmed": 12533,
                        "migratedother": 0,
                        "deceased": 130,
                        "recovered": 12388,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dindori": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 4623,
                        "migratedother": 0,
                        "deceased": 29,
                        "recovered": 4588,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Guna": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 5132,
                        "migratedother": 0,
                        "deceased": 44,
                        "recovered": 5085,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gwalior": {
                        "notes": "",
                        "active": 32,
                        "confirmed": 53092,
                        "migratedother": 0,
                        "deceased": 633,
                        "recovered": 52427,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Harda": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 5055,
                        "migratedother": 0,
                        "deceased": 96,
                        "recovered": 4954,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hoshangabad": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 10680,
                        "migratedother": 0,
                        "deceased": 99,
                        "recovered": 10570,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Indore": {
                        "notes": "",
                        "active": 210,
                        "confirmed": 153011,
                        "migratedother": 0,
                        "deceased": 1391,
                        "recovered": 151410,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jabalpur": {
                        "notes": "",
                        "active": 75,
                        "confirmed": 50641,
                        "migratedother": 0,
                        "deceased": 670,
                        "recovered": 49896,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jhabua": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 7688,
                        "migratedother": 0,
                        "deceased": 64,
                        "recovered": 7619,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Katni": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 9365,
                        "migratedother": 0,
                        "deceased": 120,
                        "recovered": 9242,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Khandwa": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 4040,
                        "migratedother": 0,
                        "deceased": 94,
                        "recovered": 3946,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Khargone": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 13965,
                        "migratedother": 0,
                        "deceased": 239,
                        "recovered": 13716,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mandla": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 5187,
                        "migratedother": 0,
                        "deceased": 25,
                        "recovered": 5159,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mandsaur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 8637,
                        "migratedother": 0,
                        "deceased": 84,
                        "recovered": 8552,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Morena": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 8236,
                        "migratedother": 0,
                        "deceased": 95,
                        "recovered": 8135,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Narsinghpur": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 11200,
                        "migratedother": 0,
                        "deceased": 81,
                        "recovered": 11115,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Neemuch": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 7924,
                        "migratedother": 0,
                        "deceased": 84,
                        "recovered": 7828,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Niwari": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 3711,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 3654,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Other Region": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Panna": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 7319,
                        "migratedother": 0,
                        "deceased": 63,
                        "recovered": 7250,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Raisen": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 9233,
                        "migratedother": 0,
                        "deceased": 194,
                        "recovered": 9030,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rajgarh": {
                        "notes": "",
                        "active": 38,
                        "confirmed": 8700,
                        "migratedother": 0,
                        "deceased": 172,
                        "recovered": 8490,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ratlam": {
                        "notes": "",
                        "active": 31,
                        "confirmed": 17854,
                        "migratedother": 0,
                        "deceased": 385,
                        "recovered": 17438,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rewa": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 16431,
                        "migratedother": 0,
                        "deceased": 155,
                        "recovered": 16270,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sagar": {
                        "notes": "",
                        "active": 48,
                        "confirmed": 16592,
                        "migratedother": 0,
                        "deceased": 390,
                        "recovered": 16154,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Satna": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 11965,
                        "migratedother": 0,
                        "deceased": 133,
                        "recovered": 11829,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sehore": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 10136,
                        "migratedother": 0,
                        "deceased": 73,
                        "recovered": 10057,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Seoni": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 6774,
                        "migratedother": 0,
                        "deceased": 28,
                        "recovered": 6739,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shahdol": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 10080,
                        "migratedother": 0,
                        "deceased": 118,
                        "recovered": 9958,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shajapur": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 6349,
                        "migratedother": 0,
                        "deceased": 74,
                        "recovered": 6273,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sheopur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 3998,
                        "migratedother": 0,
                        "deceased": 78,
                        "recovered": 3919,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shivpuri": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 12393,
                        "migratedother": 0,
                        "deceased": 125,
                        "recovered": 12261,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sidhi": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 9219,
                        "migratedother": 0,
                        "deceased": 87,
                        "recovered": 9132,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Singrauli": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 8793,
                        "migratedother": 0,
                        "deceased": 82,
                        "recovered": 8706,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tikamgarh": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 6863,
                        "migratedother": 0,
                        "deceased": 114,
                        "recovered": 6742,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ujjain": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 18896,
                        "migratedother": 0,
                        "deceased": 172,
                        "recovered": 18720,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Umaria": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 6293,
                        "migratedother": 0,
                        "deceased": 63,
                        "recovered": 6224,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Vidisha": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 11918,
                        "migratedother": 0,
                        "deceased": 237,
                        "recovered": 11677,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -860,
                        "confirmed": 1384,
                        "migratedother": 0,
                        "deceased": 1483,
                        "recovered": 761,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "MP"
            },
            "Mizoram": {
                "districtData": {
                    "Aizawl": {
                        "notes": "",
                        "active": 8728,
                        "confirmed": 31751,
                        "migratedother": 0,
                        "deceased": 135,
                        "recovered": 22888,
                        "delta": {
                            "confirmed": 590,
                            "deceased": 0,
                            "recovered": 796
                        }
                    },
                    "Champhai": {
                        "notes": "",
                        "active": 209,
                        "confirmed": 700,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 490,
                        "delta": {
                            "confirmed": 20,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hnahthial": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 116,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 103,
                        "delta": {
                            "confirmed": 11,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Khawzawl": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 109,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 108,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kolasib": {
                        "notes": "",
                        "active": 940,
                        "confirmed": 3809,
                        "migratedother": 0,
                        "deceased": 17,
                        "recovered": 2852,
                        "delta": {
                            "confirmed": 76,
                            "deceased": 0,
                            "recovered": 50
                        }
                    },
                    "Lawngtlai": {
                        "notes": "",
                        "active": 363,
                        "confirmed": 2821,
                        "migratedother": 0,
                        "deceased": 8,
                        "recovered": 2450,
                        "delta": {
                            "confirmed": 53,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Lunglei": {
                        "notes": "",
                        "active": 515,
                        "confirmed": 3534,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 3016,
                        "delta": {
                            "confirmed": 50,
                            "deceased": 1,
                            "recovered": 104
                        }
                    },
                    "Mamit": {
                        "notes": "",
                        "active": 429,
                        "confirmed": 1462,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 1031,
                        "delta": {
                            "confirmed": 53,
                            "deceased": 0,
                            "recovered": 28
                        }
                    },
                    "Saiha": {
                        "notes": "",
                        "active": 183,
                        "confirmed": 942,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 758,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 11
                        }
                    },
                    "Saitual": {
                        "notes": "",
                        "active": 15,
                        "confirmed": 222,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 205,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Serchhip": {
                        "notes": "",
                        "active": 18,
                        "confirmed": 854,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 833,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 19
                        }
                    }
                },
                "statecode": "MZ"
            },
            "Nagaland": {
                "districtData": {
                    "Others": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dimapur": {
                        "notes": "",
                        "active": 422,
                        "confirmed": 13335,
                        "migratedother": 578,
                        "deceased": 362,
                        "recovered": 11973,
                        "delta": {
                            "confirmed": 22,
                            "deceased": 2,
                            "recovered": 16
                        }
                    },
                    "Kiphire": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 228,
                        "migratedother": 1,
                        "deceased": 8,
                        "recovered": 205,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Kohima": {
                        "notes": "",
                        "active": 352,
                        "confirmed": 8765,
                        "migratedother": 144,
                        "deceased": 102,
                        "recovered": 8167,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 3,
                            "recovered": 32
                        }
                    },
                    "Longleng": {
                        "notes": "",
                        "active": 39,
                        "confirmed": 262,
                        "migratedother": 12,
                        "deceased": 2,
                        "recovered": 209,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Mokokchung": {
                        "notes": "",
                        "active": 226,
                        "confirmed": 1950,
                        "migratedother": 49,
                        "deceased": 48,
                        "recovered": 1627,
                        "delta": {
                            "confirmed": 15,
                            "deceased": 0,
                            "recovered": 13
                        }
                    },
                    "Mon": {
                        "notes": "",
                        "active": 23,
                        "confirmed": 1098,
                        "migratedother": 16,
                        "deceased": 13,
                        "recovered": 1046,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Peren": {
                        "notes": "",
                        "active": 90,
                        "confirmed": 873,
                        "migratedother": 7,
                        "deceased": 3,
                        "recovered": 773,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Phek": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 476,
                        "migratedother": 2,
                        "deceased": 17,
                        "recovered": 444,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tuensang": {
                        "notes": "",
                        "active": 67,
                        "confirmed": 985,
                        "migratedother": 3,
                        "deceased": 11,
                        "recovered": 904,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 1,
                            "recovered": 3
                        }
                    },
                    "Wokha": {
                        "notes": "",
                        "active": 39,
                        "confirmed": 326,
                        "migratedother": 11,
                        "deceased": 11,
                        "recovered": 265,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Zunheboto": {
                        "notes": "",
                        "active": 66,
                        "confirmed": 577,
                        "migratedother": 9,
                        "deceased": 14,
                        "recovered": 488,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "NL"
            },
            "Odisha": {
                "districtData": {
                    "State Pool": {
                        "notes": "",
                        "active": 762,
                        "confirmed": 27180,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 26418,
                        "delta": {
                            "confirmed": 83,
                            "deceased": 0,
                            "recovered": 50
                        }
                    },
                    "Others": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Angul": {
                        "notes": "",
                        "active": 212,
                        "confirmed": 43056,
                        "migratedother": 0,
                        "deceased": 279,
                        "recovered": 42565,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 5,
                            "recovered": 32
                        }
                    },
                    "Balangir": {
                        "notes": "",
                        "active": 36,
                        "confirmed": 23218,
                        "migratedother": 0,
                        "deceased": 112,
                        "recovered": 23070,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Balasore": {
                        "notes": "",
                        "active": 526,
                        "confirmed": 38584,
                        "migratedother": 0,
                        "deceased": 227,
                        "recovered": 37831,
                        "delta": {
                            "confirmed": 45,
                            "deceased": 3,
                            "recovered": 61
                        }
                    },
                    "Bargarh": {
                        "notes": "",
                        "active": 62,
                        "confirmed": 30775,
                        "migratedother": 0,
                        "deceased": 306,
                        "recovered": 30407,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 1,
                            "recovered": 7
                        }
                    },
                    "Bhadrak": {
                        "notes": "",
                        "active": 310,
                        "confirmed": 25719,
                        "migratedother": 0,
                        "deceased": 98,
                        "recovered": 25311,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 0,
                            "recovered": 46
                        }
                    },
                    "Boudh": {
                        "notes": "",
                        "active": 20,
                        "confirmed": 12528,
                        "migratedother": 0,
                        "deceased": 106,
                        "recovered": 12402,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Cuttack": {
                        "notes": "",
                        "active": 1209,
                        "confirmed": 88249,
                        "migratedother": 0,
                        "deceased": 460,
                        "recovered": 86580,
                        "delta": {
                            "confirmed": 147,
                            "deceased": 12,
                            "recovered": 123
                        }
                    },
                    "Deogarh": {
                        "notes": "",
                        "active": 30,
                        "confirmed": 6213,
                        "migratedother": 0,
                        "deceased": 42,
                        "recovered": 6141,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Dhenkanal": {
                        "notes": "",
                        "active": 158,
                        "confirmed": 19231,
                        "migratedother": 0,
                        "deceased": 134,
                        "recovered": 18939,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 2,
                            "recovered": 10
                        }
                    },
                    "Gajapati": {
                        "notes": "",
                        "active": 16,
                        "confirmed": 9531,
                        "migratedother": 0,
                        "deceased": 83,
                        "recovered": 9432,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Ganjam": {
                        "notes": "",
                        "active": 38,
                        "confirmed": 33502,
                        "migratedother": 0,
                        "deceased": 470,
                        "recovered": 32994,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 12
                        }
                    },
                    "Jagatsinghpur": {
                        "notes": "",
                        "active": 496,
                        "confirmed": 26084,
                        "migratedother": 0,
                        "deceased": 110,
                        "recovered": 25478,
                        "delta": {
                            "confirmed": 58,
                            "deceased": 3,
                            "recovered": 59
                        }
                    },
                    "Jajpur": {
                        "notes": "",
                        "active": 533,
                        "confirmed": 41724,
                        "migratedother": 0,
                        "deceased": 85,
                        "recovered": 41106,
                        "delta": {
                            "confirmed": 58,
                            "deceased": 1,
                            "recovered": 42
                        }
                    },
                    "Jharsuguda": {
                        "notes": "",
                        "active": 27,
                        "confirmed": 23624,
                        "migratedother": 0,
                        "deceased": 168,
                        "recovered": 23429,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kalahandi": {
                        "notes": "",
                        "active": 33,
                        "confirmed": 24172,
                        "migratedother": 0,
                        "deceased": 203,
                        "recovered": 23936,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 1,
                            "recovered": 7
                        }
                    },
                    "Kandhamal": {
                        "notes": "",
                        "active": 73,
                        "confirmed": 11397,
                        "migratedother": 0,
                        "deceased": 81,
                        "recovered": 11243,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Kendrapara": {
                        "notes": "",
                        "active": 256,
                        "confirmed": 23736,
                        "migratedother": 0,
                        "deceased": 155,
                        "recovered": 23325,
                        "delta": {
                            "confirmed": 51,
                            "deceased": 3,
                            "recovered": 25
                        }
                    },
                    "Kendujhar": {
                        "notes": "",
                        "active": 114,
                        "confirmed": 20534,
                        "migratedother": 0,
                        "deceased": 147,
                        "recovered": 20273,
                        "delta": {
                            "confirmed": 12,
                            "deceased": 2,
                            "recovered": 4
                        }
                    },
                    "Khordha": {
                        "notes": "",
                        "active": 3456,
                        "confirmed": 153972,
                        "migratedother": 0,
                        "deceased": 1365,
                        "recovered": 149151,
                        "delta": {
                            "confirmed": 372,
                            "deceased": 20,
                            "recovered": 232
                        }
                    },
                    "Koraput": {
                        "notes": "",
                        "active": 48,
                        "confirmed": 18883,
                        "migratedother": 0,
                        "deceased": 73,
                        "recovered": 18762,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Malkangiri": {
                        "notes": "",
                        "active": 41,
                        "confirmed": 11522,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 11433,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Mayurbhanj": {
                        "notes": "",
                        "active": 294,
                        "confirmed": 39008,
                        "migratedother": 0,
                        "deceased": 234,
                        "recovered": 38480,
                        "delta": {
                            "confirmed": 35,
                            "deceased": 2,
                            "recovered": 18
                        }
                    },
                    "Nabarangapur": {
                        "notes": "",
                        "active": 21,
                        "confirmed": 23472,
                        "migratedother": 0,
                        "deceased": 66,
                        "recovered": 23385,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Nayagarh": {
                        "notes": "",
                        "active": 249,
                        "confirmed": 22829,
                        "migratedother": 0,
                        "deceased": 166,
                        "recovered": 22414,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 6,
                            "recovered": 7
                        }
                    },
                    "Nuapada": {
                        "notes": "",
                        "active": 23,
                        "confirmed": 22812,
                        "migratedother": 0,
                        "deceased": 83,
                        "recovered": 22706,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Puri": {
                        "notes": "",
                        "active": 425,
                        "confirmed": 44013,
                        "migratedother": 0,
                        "deceased": 408,
                        "recovered": 43180,
                        "delta": {
                            "confirmed": 48,
                            "deceased": 3,
                            "recovered": 45
                        }
                    },
                    "Rayagada": {
                        "notes": "",
                        "active": 101,
                        "confirmed": 19887,
                        "migratedother": 0,
                        "deceased": 161,
                        "recovered": 19625,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 1,
                            "recovered": 6
                        }
                    },
                    "Sambalpur": {
                        "notes": "",
                        "active": 99,
                        "confirmed": 30621,
                        "migratedother": 0,
                        "deceased": 195,
                        "recovered": 30327,
                        "delta": {
                            "confirmed": 12,
                            "deceased": 0,
                            "recovered": 10
                        }
                    },
                    "Subarnapur": {
                        "notes": "",
                        "active": 50,
                        "confirmed": 13098,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 13000,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Sundargarh": {
                        "notes": "",
                        "active": 95,
                        "confirmed": 60901,
                        "migratedother": 0,
                        "deceased": 570,
                        "recovered": 60236,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 23
                        }
                    }
                },
                "statecode": "OR"
            },
            "Punjab": {
                "districtData": {
                    "Amritsar": {
                        "notes": "",
                        "active": 32,
                        "confirmed": 47118,
                        "migratedother": 0,
                        "deceased": 1587,
                        "recovered": 45499,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Barnala": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 5912,
                        "migratedother": 0,
                        "deceased": 242,
                        "recovered": 5656,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Bathinda": {
                        "notes": "",
                        "active": 34,
                        "confirmed": 41547,
                        "migratedother": 0,
                        "deceased": 1039,
                        "recovered": 40474,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Faridkot": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 13836,
                        "migratedother": 0,
                        "deceased": 313,
                        "recovered": 13515,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Fatehgarh Sahib": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 8797,
                        "migratedother": 0,
                        "deceased": 291,
                        "recovered": 8499,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 2,
                            "recovered": 0
                        }
                    },
                    "Fazilka": {
                        "notes": "",
                        "active": 44,
                        "confirmed": 20184,
                        "migratedother": 0,
                        "deceased": 526,
                        "recovered": 19614,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Ferozepur": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 14245,
                        "migratedother": 0,
                        "deceased": 499,
                        "recovered": 13733,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 1,
                            "recovered": 3
                        }
                    },
                    "Gurdaspur": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 22246,
                        "migratedother": 0,
                        "deceased": 797,
                        "recovered": 21440,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Hoshiarpur": {
                        "notes": "",
                        "active": 23,
                        "confirmed": 30674,
                        "migratedother": 0,
                        "deceased": 978,
                        "recovered": 29673,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Jalandhar": {
                        "notes": "",
                        "active": 61,
                        "confirmed": 63162,
                        "migratedother": 0,
                        "deceased": 1490,
                        "recovered": 61611,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Kapurthala": {
                        "notes": "",
                        "active": 13,
                        "confirmed": 17771,
                        "migratedother": 0,
                        "deceased": 553,
                        "recovered": 17205,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 6
                        }
                    },
                    "Ludhiana": {
                        "notes": "",
                        "active": 99,
                        "confirmed": 87401,
                        "migratedother": 0,
                        "deceased": 2095,
                        "recovered": 85207,
                        "delta": {
                            "confirmed": 34,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Mansa": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 15575,
                        "migratedother": 0,
                        "deceased": 311,
                        "recovered": 15263,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Moga": {
                        "notes": "",
                        "active": 16,
                        "confirmed": 8628,
                        "migratedother": 0,
                        "deceased": 233,
                        "recovered": 8379,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pathankot": {
                        "notes": "",
                        "active": 22,
                        "confirmed": 18607,
                        "migratedother": 0,
                        "deceased": 416,
                        "recovered": 18169,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Patiala": {
                        "notes": "",
                        "active": 34,
                        "confirmed": 48752,
                        "migratedother": 0,
                        "deceased": 1341,
                        "recovered": 47377,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rupnagar": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 12880,
                        "migratedother": 0,
                        "deceased": 417,
                        "recovered": 12454,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "S.A.S. Nagar": {
                        "notes": "",
                        "active": 46,
                        "confirmed": 68505,
                        "migratedother": 0,
                        "deceased": 1057,
                        "recovered": 67402,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Sangrur": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 15693,
                        "migratedother": 0,
                        "deceased": 868,
                        "recovered": 14816,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Shahid Bhagat Singh Nagar": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 11429,
                        "migratedother": 0,
                        "deceased": 374,
                        "recovered": 11052,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sri Muktsar Sahib": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 18730,
                        "migratedother": 0,
                        "deceased": 523,
                        "recovered": 18199,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tarn Taran": {
                        "notes": "",
                        "active": 12,
                        "confirmed": 7986,
                        "migratedother": 0,
                        "deceased": 375,
                        "recovered": 7599,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 1
                        }
                    }
                },
                "statecode": "PB"
            },
            "Puducherry": {
                "districtData": {
                    "Karaikal": {
                        "notes": "2 case of TN has been transferred,so has been reduced from the total count.",
                        "active": 119,
                        "confirmed": 15157,
                        "migratedother": 0,
                        "deceased": 231,
                        "recovered": 14807,
                        "delta": {
                            "confirmed": 22,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Mahe": {
                        "notes": "1 case of KL have been transferred,so have been reduced from the total count",
                        "active": 143,
                        "confirmed": 4977,
                        "migratedother": 0,
                        "deceased": 38,
                        "recovered": 4796,
                        "delta": {
                            "confirmed": 20,
                            "deceased": 0,
                            "recovered": 13
                        }
                    },
                    "Puducherry": {
                        "notes": "209 cases(204 of TN, 1 of AP and 4 other) have been transferred,so have been reduced from the total count.[July 18]4 cases have transferred to TN and have been reduced from recovered cases.",
                        "active": 581,
                        "confirmed": 95120,
                        "migratedother": 0,
                        "deceased": 1427,
                        "recovered": 93112,
                        "delta": {
                            "confirmed": 70,
                            "deceased": 1,
                            "recovered": 77
                        }
                    },
                    "Yanam": {
                        "notes": "2 cases of AP have been transferred,so have been reduced from the total count",
                        "active": 23,
                        "confirmed": 6626,
                        "migratedother": 0,
                        "deceased": 105,
                        "recovered": 6498,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 4
                        }
                    }
                },
                "statecode": "PY"
            },
            "Rajasthan": {
                "districtData": {
                    "Ajmer": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 37715,
                        "migratedother": 0,
                        "deceased": 410,
                        "recovered": 37291,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Alwar": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 59652,
                        "migratedother": 0,
                        "deceased": 307,
                        "recovered": 59335,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Banswara": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 10005,
                        "migratedother": 0,
                        "deceased": 104,
                        "recovered": 9898,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Baran": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 11993,
                        "migratedother": 0,
                        "deceased": 61,
                        "recovered": 11931,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Barmer": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 15550,
                        "migratedother": 0,
                        "deceased": 185,
                        "recovered": 15361,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bharatpur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 19590,
                        "migratedother": 0,
                        "deceased": 260,
                        "recovered": 19329,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bhilwara": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 29773,
                        "migratedother": 0,
                        "deceased": 156,
                        "recovered": 29617,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bikaner": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 40311,
                        "migratedother": 0,
                        "deceased": 545,
                        "recovered": 39759,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "BSF Camp": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 85,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 85,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bundi": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 7967,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 7919,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chittorgarh": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 19809,
                        "migratedother": 0,
                        "deceased": 139,
                        "recovered": 19670,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Churu": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 16719,
                        "migratedother": 0,
                        "deceased": 107,
                        "recovered": 16612,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dausa": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 13351,
                        "migratedother": 0,
                        "deceased": 62,
                        "recovered": 13287,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dholpur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 11006,
                        "migratedother": 0,
                        "deceased": 48,
                        "recovered": 10957,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dungarpur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 18407,
                        "migratedother": 0,
                        "deceased": 131,
                        "recovered": 18276,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Evacuees": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 61,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 61,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ganganagar": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 19336,
                        "migratedother": 0,
                        "deceased": 150,
                        "recovered": 19186,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hanumangarh": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 16050,
                        "migratedother": 0,
                        "deceased": 111,
                        "recovered": 15935,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Italians": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 2,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jaipur": {
                        "notes": "",
                        "active": 60,
                        "confirmed": 187598,
                        "migratedother": 0,
                        "deceased": 1970,
                        "recovered": 185568,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Jaisalmer": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 13639,
                        "migratedother": 0,
                        "deceased": 66,
                        "recovered": 13570,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jalore": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 10065,
                        "migratedother": 0,
                        "deceased": 72,
                        "recovered": 9989,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jhalawar": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 13599,
                        "migratedother": 0,
                        "deceased": 187,
                        "recovered": 13411,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jhunjhunu": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 14802,
                        "migratedother": 0,
                        "deceased": 158,
                        "recovered": 14644,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jodhpur": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 112374,
                        "migratedother": 0,
                        "deceased": 1103,
                        "recovered": 111271,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Karauli": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 7156,
                        "migratedother": 0,
                        "deceased": 70,
                        "recovered": 7086,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kota": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 57051,
                        "migratedother": 0,
                        "deceased": 449,
                        "recovered": 56601,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nagaur": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 17727,
                        "migratedother": 0,
                        "deceased": 177,
                        "recovered": 17543,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 189,
                        "migratedother": 0,
                        "deceased": 39,
                        "recovered": 150,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pali": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 27315,
                        "migratedother": 0,
                        "deceased": 287,
                        "recovered": 27017,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pratapgarh": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 7143,
                        "migratedother": 0,
                        "deceased": 63,
                        "recovered": 7075,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rajsamand": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 17041,
                        "migratedother": 0,
                        "deceased": 169,
                        "recovered": 16870,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sawai Madhopur": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 10602,
                        "migratedother": 0,
                        "deceased": 61,
                        "recovered": 10537,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sikar": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 30605,
                        "migratedother": 0,
                        "deceased": 335,
                        "recovered": 30264,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Sirohi": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 13729,
                        "migratedother": 0,
                        "deceased": 79,
                        "recovered": 13650,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Tonk": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 9495,
                        "migratedother": 0,
                        "deceased": 92,
                        "recovered": 9402,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Udaipur": {
                        "notes": "",
                        "active": 43,
                        "confirmed": 56358,
                        "migratedother": 0,
                        "deceased": 753,
                        "recovered": 55562,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 7
                        }
                    }
                },
                "statecode": "RJ"
            },
            "Sikkim": {
                "districtData": {
                    "East Sikkim": {
                        "notes": "",
                        "active": 10831,
                        "confirmed": 15974,
                        "migratedother": 78,
                        "deceased": 148,
                        "recovered": 4917,
                        "delta": {
                            "confirmed": 47,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "North Sikkim": {
                        "notes": "",
                        "active": 699,
                        "confirmed": 781,
                        "migratedother": 9,
                        "deceased": 1,
                        "recovered": 72,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "South Sikkim": {
                        "notes": "",
                        "active": 5723,
                        "confirmed": 6178,
                        "migratedother": 15,
                        "deceased": 2,
                        "recovered": 438,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "West Sikkim": {
                        "notes": "",
                        "active": 4792,
                        "confirmed": 4973,
                        "migratedother": 25,
                        "deceased": 19,
                        "recovered": 137,
                        "delta": {
                            "confirmed": 81,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -19502,
                        "confirmed": 269,
                        "migratedother": 151,
                        "deceased": 189,
                        "recovered": 19431,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "SK"
            },
            "Telangana": {
                "districtData": {
                    "Foreign Evacuees": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 33,
                        "confirmed": 33,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Other State": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 250,
                        "confirmed": 250,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Adilabad": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 7085,
                        "confirmed": 7100,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 15,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bhadradri Kothagudem": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 18328,
                        "confirmed": 18332,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 4,
                        "delta": {
                            "confirmed": 10,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hyderabad": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 136563,
                        "confirmed": 136891,
                        "migratedother": 0,
                        "deceased": 23,
                        "recovered": 305,
                        "delta": {
                            "confirmed": 82,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jagtial": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 16969,
                        "confirmed": 16971,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 19,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jangaon": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 7523,
                        "confirmed": 7524,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jayashankar Bhupalapally": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 6760,
                        "confirmed": 6760,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jogulamba Gadwal": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 7156,
                        "confirmed": 7182,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 25,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kamareddy": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 11510,
                        "confirmed": 11518,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 8,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Karimnagar": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 29287,
                        "confirmed": 29303,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 16,
                        "delta": {
                            "confirmed": 61,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Khammam": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 26949,
                        "confirmed": 26952,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 3,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Komaram Bheem": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 4461,
                        "confirmed": 4463,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mahabubabad": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 12855,
                        "confirmed": 12856,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mahabubnagar": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 16218,
                        "confirmed": 16226,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 8,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mancherial": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 15913,
                        "confirmed": 15914,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Medak": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 8388,
                        "confirmed": 8392,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 4,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Medchal Malkajgiri": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 44944,
                        "confirmed": 44954,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 9,
                        "delta": {
                            "confirmed": 23,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mulugu": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 6572,
                        "confirmed": 6574,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nagarkurnool": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 12228,
                        "confirmed": 12230,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nalgonda": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 28624,
                        "confirmed": 28636,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 12,
                        "delta": {
                            "confirmed": 35,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Narayanpet": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 3271,
                        "confirmed": 3272,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nirmal": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 7217,
                        "confirmed": 7230,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 13,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Nizamabad": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 20746,
                        "confirmed": 20776,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 30,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Peddapalli": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 15416,
                        "confirmed": 15417,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1,
                        "delta": {
                            "confirmed": 23,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rajanna Sircilla": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 11924,
                        "confirmed": 11926,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 2,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ranga Reddy": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 48325,
                        "confirmed": 48344,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 17,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sangareddy": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 19029,
                        "confirmed": 19035,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 6,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Siddipet": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 19167,
                        "confirmed": 19168,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 1,
                        "delta": {
                            "confirmed": 11,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Suryapet": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 17243,
                        "confirmed": 17267,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 24,
                        "delta": {
                            "confirmed": 17,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Vikarabad": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 10917,
                        "confirmed": 10933,
                        "migratedother": 0,
                        "deceased": 1,
                        "recovered": 15,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Wanaparthy": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 9674,
                        "confirmed": 9674,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Warangal Rural": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 10500,
                        "confirmed": 10500,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Warangal Urban": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 26021,
                        "confirmed": 26044,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 23,
                        "delta": {
                            "confirmed": 41,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Yadadri Bhuvanagiri": {
                        "notes": "District-wise numbers are out-dated as cumulative counts for each district are not reported in Telangana bulletin",
                        "active": 11133,
                        "confirmed": 11133,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unknown": {
                        "notes": "",
                        "active": -641062,
                        "confirmed": 1055,
                        "migratedother": 0,
                        "deceased": 3803,
                        "recovered": 638314,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    }
                },
                "statecode": "TG"
            },
            "Tamil Nadu": {
                "districtData": {
                    "Railway Quarantine": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 428,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 428,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Airport Quarantine": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 2098,
                        "migratedother": 0,
                        "deceased": 2,
                        "recovered": 2088,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 0,
                        "migratedother": 0,
                        "deceased": 0,
                        "recovered": 0,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ariyalur": {
                        "notes": "",
                        "active": 237,
                        "confirmed": 16037,
                        "migratedother": 0,
                        "deceased": 240,
                        "recovered": 15560,
                        "delta": {
                            "confirmed": 21,
                            "deceased": 1,
                            "recovered": 26
                        }
                    },
                    "Chengalpattu": {
                        "notes": "",
                        "active": 1152,
                        "confirmed": 163274,
                        "migratedother": 0,
                        "deceased": 2413,
                        "recovered": 159709,
                        "delta": {
                            "confirmed": 139,
                            "deceased": 0,
                            "recovered": 117
                        }
                    },
                    "Chennai": {
                        "notes": "[July 22]: 444 backdated deceased entries added to Chennai in TN bulletin.",
                        "active": 2048,
                        "confirmed": 540300,
                        "migratedother": 0,
                        "deceased": 8345,
                        "recovered": 529907,
                        "delta": {
                            "confirmed": 237,
                            "deceased": 3,
                            "recovered": 191
                        }
                    },
                    "Coimbatore": {
                        "notes": "",
                        "active": 2259,
                        "confirmed": 231863,
                        "migratedother": 0,
                        "deceased": 2201,
                        "recovered": 227403,
                        "delta": {
                            "confirmed": 230,
                            "deceased": 2,
                            "recovered": 203
                        }
                    },
                    "Cuddalore": {
                        "notes": "",
                        "active": 777,
                        "confirmed": 61220,
                        "migratedother": 0,
                        "deceased": 821,
                        "recovered": 59622,
                        "delta": {
                            "confirmed": 76,
                            "deceased": 0,
                            "recovered": 47
                        }
                    },
                    "Dharmapuri": {
                        "notes": "",
                        "active": 316,
                        "confirmed": 26415,
                        "migratedother": 0,
                        "deceased": 237,
                        "recovered": 25862,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 0,
                            "recovered": 34
                        }
                    },
                    "Dindigul": {
                        "notes": "",
                        "active": 157,
                        "confirmed": 32322,
                        "migratedother": 0,
                        "deceased": 627,
                        "recovered": 31538,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 1,
                            "recovered": 15
                        }
                    },
                    "Erode": {
                        "notes": "",
                        "active": 1710,
                        "confirmed": 95559,
                        "migratedother": 0,
                        "deceased": 641,
                        "recovered": 93208,
                        "delta": {
                            "confirmed": 160,
                            "deceased": 1,
                            "recovered": 174
                        }
                    },
                    "Kallakurichi": {
                        "notes": "",
                        "active": 468,
                        "confirmed": 29521,
                        "migratedother": 0,
                        "deceased": 199,
                        "recovered": 28854,
                        "delta": {
                            "confirmed": 31,
                            "deceased": 0,
                            "recovered": 42
                        }
                    },
                    "Kancheepuram": {
                        "notes": "",
                        "active": 448,
                        "confirmed": 72144,
                        "migratedother": 0,
                        "deceased": 1213,
                        "recovered": 70483,
                        "delta": {
                            "confirmed": 42,
                            "deceased": 1,
                            "recovered": 36
                        }
                    },
                    "Kanyakumari": {
                        "notes": "",
                        "active": 339,
                        "confirmed": 60451,
                        "migratedother": 0,
                        "deceased": 1022,
                        "recovered": 59090,
                        "delta": {
                            "confirmed": 30,
                            "deceased": 0,
                            "recovered": 28
                        }
                    },
                    "Karur": {
                        "notes": "",
                        "active": 188,
                        "confirmed": 22836,
                        "migratedother": 0,
                        "deceased": 351,
                        "recovered": 22297,
                        "delta": {
                            "confirmed": 23,
                            "deceased": 0,
                            "recovered": 12
                        }
                    },
                    "Krishnagiri": {
                        "notes": "",
                        "active": 309,
                        "confirmed": 41638,
                        "migratedother": 0,
                        "deceased": 325,
                        "recovered": 41004,
                        "delta": {
                            "confirmed": 26,
                            "deceased": 1,
                            "recovered": 37
                        }
                    },
                    "Madurai": {
                        "notes": "",
                        "active": 228,
                        "confirmed": 73729,
                        "migratedother": 0,
                        "deceased": 1147,
                        "recovered": 72354,
                        "delta": {
                            "confirmed": 15,
                            "deceased": 0,
                            "recovered": 18
                        }
                    },
                    "Nagapattinam": {
                        "notes": "",
                        "active": 427,
                        "confirmed": 19075,
                        "migratedother": 0,
                        "deceased": 295,
                        "recovered": 18353,
                        "delta": {
                            "confirmed": 36,
                            "deceased": 3,
                            "recovered": 43
                        }
                    },
                    "Namakkal": {
                        "notes": "",
                        "active": 574,
                        "confirmed": 47771,
                        "migratedother": 0,
                        "deceased": 458,
                        "recovered": 46739,
                        "delta": {
                            "confirmed": 37,
                            "deceased": 0,
                            "recovered": 57
                        }
                    },
                    "Nilgiris": {
                        "notes": "",
                        "active": 493,
                        "confirmed": 31048,
                        "migratedother": 0,
                        "deceased": 186,
                        "recovered": 30369,
                        "delta": {
                            "confirmed": 43,
                            "deceased": 0,
                            "recovered": 51
                        }
                    },
                    "Perambalur": {
                        "notes": "",
                        "active": 109,
                        "confirmed": 11579,
                        "migratedother": 0,
                        "deceased": 225,
                        "recovered": 11245,
                        "delta": {
                            "confirmed": 10,
                            "deceased": 0,
                            "recovered": 10
                        }
                    },
                    "Pudukkottai": {
                        "notes": "",
                        "active": 356,
                        "confirmed": 28533,
                        "migratedother": 0,
                        "deceased": 372,
                        "recovered": 27805,
                        "delta": {
                            "confirmed": 39,
                            "deceased": 0,
                            "recovered": 23
                        }
                    },
                    "Ramanathapuram": {
                        "notes": "",
                        "active": 94,
                        "confirmed": 20110,
                        "migratedother": 0,
                        "deceased": 351,
                        "recovered": 19665,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 13
                        }
                    },
                    "Ranipet": {
                        "notes": "",
                        "active": 216,
                        "confirmed": 42169,
                        "migratedother": 0,
                        "deceased": 745,
                        "recovered": 41208,
                        "delta": {
                            "confirmed": 22,
                            "deceased": 0,
                            "recovered": 22
                        }
                    },
                    "Salem": {
                        "notes": "",
                        "active": 843,
                        "confirmed": 94328,
                        "migratedother": 0,
                        "deceased": 1597,
                        "recovered": 91888,
                        "delta": {
                            "confirmed": 86,
                            "deceased": 3,
                            "recovered": 87
                        }
                    },
                    "Sivaganga": {
                        "notes": "",
                        "active": 229,
                        "confirmed": 19022,
                        "migratedother": 0,
                        "deceased": 199,
                        "recovered": 18594,
                        "delta": {
                            "confirmed": 21,
                            "deceased": 0,
                            "recovered": 24
                        }
                    },
                    "Tenkasi": {
                        "notes": "",
                        "active": 112,
                        "confirmed": 26928,
                        "migratedother": 0,
                        "deceased": 484,
                        "recovered": 26332,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 11
                        }
                    },
                    "Thanjavur": {
                        "notes": "",
                        "active": 995,
                        "confirmed": 68972,
                        "migratedother": 0,
                        "deceased": 864,
                        "recovered": 67113,
                        "delta": {
                            "confirmed": 77,
                            "deceased": 2,
                            "recovered": 82
                        }
                    },
                    "Theni": {
                        "notes": "",
                        "active": 120,
                        "confirmed": 43038,
                        "migratedother": 0,
                        "deceased": 514,
                        "recovered": 42404,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 14
                        }
                    },
                    "Thiruvallur": {
                        "notes": "",
                        "active": 941,
                        "confirmed": 114461,
                        "migratedother": 0,
                        "deceased": 1766,
                        "recovered": 111754,
                        "delta": {
                            "confirmed": 100,
                            "deceased": 1,
                            "recovered": 83
                        }
                    },
                    "Thiruvarur": {
                        "notes": "",
                        "active": 432,
                        "confirmed": 38327,
                        "migratedother": 0,
                        "deceased": 376,
                        "recovered": 37519,
                        "delta": {
                            "confirmed": 40,
                            "deceased": 1,
                            "recovered": 38
                        }
                    },
                    "Thoothukkudi": {
                        "notes": "",
                        "active": 196,
                        "confirmed": 55274,
                        "migratedother": 0,
                        "deceased": 398,
                        "recovered": 54680,
                        "delta": {
                            "confirmed": 18,
                            "deceased": 0,
                            "recovered": 21
                        }
                    },
                    "Tiruchirappalli": {
                        "notes": "",
                        "active": 749,
                        "confirmed": 73209,
                        "migratedother": 0,
                        "deceased": 979,
                        "recovered": 71481,
                        "delta": {
                            "confirmed": 74,
                            "deceased": 3,
                            "recovered": 74
                        }
                    },
                    "Tirunelveli": {
                        "notes": "",
                        "active": 252,
                        "confirmed": 48151,
                        "migratedother": 0,
                        "deceased": 430,
                        "recovered": 47469,
                        "delta": {
                            "confirmed": 14,
                            "deceased": 0,
                            "recovered": 26
                        }
                    },
                    "Tirupathur": {
                        "notes": "",
                        "active": 178,
                        "confirmed": 28410,
                        "migratedother": 0,
                        "deceased": 604,
                        "recovered": 27628,
                        "delta": {
                            "confirmed": 10,
                            "deceased": 0,
                            "recovered": 19
                        }
                    },
                    "Tiruppur": {
                        "notes": "",
                        "active": 857,
                        "confirmed": 88754,
                        "migratedother": 0,
                        "deceased": 876,
                        "recovered": 87021,
                        "delta": {
                            "confirmed": 78,
                            "deceased": 2,
                            "recovered": 67
                        }
                    },
                    "Tiruvannamalai": {
                        "notes": "",
                        "active": 503,
                        "confirmed": 52586,
                        "migratedother": 0,
                        "deceased": 641,
                        "recovered": 51442,
                        "delta": {
                            "confirmed": 52,
                            "deceased": 1,
                            "recovered": 66
                        }
                    },
                    "Vellore": {
                        "notes": "",
                        "active": 308,
                        "confirmed": 48356,
                        "migratedother": 0,
                        "deceased": 1097,
                        "recovered": 46951,
                        "delta": {
                            "confirmed": 39,
                            "deceased": 1,
                            "recovered": 27
                        }
                    },
                    "Viluppuram": {
                        "notes": "",
                        "active": 358,
                        "confirmed": 44205,
                        "migratedother": 0,
                        "deceased": 341,
                        "recovered": 43506,
                        "delta": {
                            "confirmed": 37,
                            "deceased": 0,
                            "recovered": 33
                        }
                    },
                    "Virudhunagar": {
                        "notes": "",
                        "active": 137,
                        "confirmed": 45628,
                        "migratedother": 0,
                        "deceased": 542,
                        "recovered": 44949,
                        "delta": {
                            "confirmed": 10,
                            "deceased": 1,
                            "recovered": 20
                        }
                    },
                    "Mayiladuthurai": {
                        "notes": "",
                        "active": 259,
                        "confirmed": 21325,
                        "migratedother": 0,
                        "deceased": 271,
                        "recovered": 20795,
                        "delta": {
                            "confirmed": 25,
                            "deceased": 0,
                            "recovered": 24
                        }
                    }
                },
                "statecode": "TN"
            },
            "Tripura": {
                "districtData": {
                    "Dhalai": {
                        "notes": "",
                        "active": 107,
                        "confirmed": 6866,
                        "migratedother": 1,
                        "deceased": 34,
                        "recovered": 6724,
                        "delta": {
                            "confirmed": 17,
                            "deceased": 0,
                            "recovered": 14
                        }
                    },
                    "Gomati": {
                        "notes": "",
                        "active": 252,
                        "confirmed": 7796,
                        "migratedother": 4,
                        "deceased": 71,
                        "recovered": 7469,
                        "delta": {
                            "confirmed": 20,
                            "deceased": 1,
                            "recovered": 23
                        }
                    },
                    "Khowai": {
                        "notes": "",
                        "active": 76,
                        "confirmed": 4466,
                        "migratedother": 0,
                        "deceased": 52,
                        "recovered": 4338,
                        "delta": {
                            "confirmed": 12,
                            "deceased": 0,
                            "recovered": 11
                        }
                    },
                    "North Tripura": {
                        "notes": "",
                        "active": 182,
                        "confirmed": 6912,
                        "migratedother": 7,
                        "deceased": 32,
                        "recovered": 6691,
                        "delta": {
                            "confirmed": 34,
                            "deceased": 0,
                            "recovered": 23
                        }
                    },
                    "Sipahijala": {
                        "notes": "",
                        "active": 83,
                        "confirmed": 6118,
                        "migratedother": 1,
                        "deceased": 74,
                        "recovered": 5960,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 10
                        }
                    },
                    "South Tripura": {
                        "notes": "",
                        "active": 277,
                        "confirmed": 9759,
                        "migratedother": 3,
                        "deceased": 45,
                        "recovered": 9434,
                        "delta": {
                            "confirmed": 31,
                            "deceased": 0,
                            "recovered": 25
                        }
                    },
                    "Unokoti": {
                        "notes": "",
                        "active": 299,
                        "confirmed": 8209,
                        "migratedother": 4,
                        "deceased": 58,
                        "recovered": 7848,
                        "delta": {
                            "confirmed": 50,
                            "deceased": 0,
                            "recovered": 25
                        }
                    },
                    "West Tripura": {
                        "notes": "",
                        "active": 800,
                        "confirmed": 30531,
                        "migratedother": 43,
                        "deceased": 404,
                        "recovered": 29284,
                        "delta": {
                            "confirmed": 74,
                            "deceased": 1,
                            "recovered": 79
                        }
                    }
                },
                "statecode": "TR"
            },
            "Uttar Pradesh": {
                "districtData": {
                    "Agra": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 25734,
                        "migratedother": 0,
                        "deceased": 457,
                        "recovered": 25269,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Aligarh": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 21276,
                        "migratedother": 0,
                        "deceased": 108,
                        "recovered": 21168,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ambedkar Nagar": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 5028,
                        "migratedother": 0,
                        "deceased": 150,
                        "recovered": 4873,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Amethi": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 9958,
                        "migratedother": 0,
                        "deceased": 143,
                        "recovered": 9815,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Amroha": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 16610,
                        "migratedother": 0,
                        "deceased": 203,
                        "recovered": 16405,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Auraiya": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 10079,
                        "migratedother": 0,
                        "deceased": 203,
                        "recovered": 9875,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Ayodhya": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 16912,
                        "migratedother": 0,
                        "deceased": 290,
                        "recovered": 16620,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Azamgarh": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 17886,
                        "migratedother": 0,
                        "deceased": 228,
                        "recovered": 17654,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Baghpat": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 9128,
                        "migratedother": 0,
                        "deceased": 141,
                        "recovered": 8985,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Bahraich": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 11546,
                        "migratedother": 0,
                        "deceased": 178,
                        "recovered": 11366,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Ballia": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 21606,
                        "migratedother": 0,
                        "deceased": 233,
                        "recovered": 21372,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Balrampur": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 7487,
                        "migratedother": 0,
                        "deceased": 138,
                        "recovered": 7346,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Banda": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 10985,
                        "migratedother": 0,
                        "deceased": 153,
                        "recovered": 10831,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Barabanki": {
                        "notes": "",
                        "active": 8,
                        "confirmed": 19832,
                        "migratedother": 0,
                        "deceased": 225,
                        "recovered": 19599,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Bareilly": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 43970,
                        "migratedother": 0,
                        "deceased": 376,
                        "recovered": 43591,
                        "delta": {
                            "confirmed": -1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Basti": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 11714,
                        "migratedother": 0,
                        "deceased": 330,
                        "recovered": 11383,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bhadohi": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 7717,
                        "migratedother": 0,
                        "deceased": 163,
                        "recovered": 7552,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bijnor": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 14788,
                        "migratedother": 0,
                        "deceased": 108,
                        "recovered": 14679,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Budaun": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 14924,
                        "migratedother": 0,
                        "deceased": 98,
                        "recovered": 14825,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bulandshahr": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 20201,
                        "migratedother": 0,
                        "deceased": 241,
                        "recovered": 19958,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chandauli": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 16198,
                        "migratedother": 0,
                        "deceased": 356,
                        "recovered": 15839,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Chitrakoot": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 7106,
                        "migratedother": 0,
                        "deceased": 79,
                        "recovered": 7027,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Deoria": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 20212,
                        "migratedother": 0,
                        "deceased": 218,
                        "recovered": 19988,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Etah": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 9963,
                        "migratedother": 0,
                        "deceased": 98,
                        "recovered": 9865,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Etawah": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 13928,
                        "migratedother": 0,
                        "deceased": 293,
                        "recovered": 13632,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Farrukhabad": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 10340,
                        "migratedother": 0,
                        "deceased": 194,
                        "recovered": 10144,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Fatehpur": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 6800,
                        "migratedother": 0,
                        "deceased": 139,
                        "recovered": 6658,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Firozabad": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 8715,
                        "migratedother": 0,
                        "deceased": 135,
                        "recovered": 8580,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gautam Buddha Nagar": {
                        "notes": "",
                        "active": 16,
                        "confirmed": 63228,
                        "migratedother": 0,
                        "deceased": 466,
                        "recovered": 62746,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Ghaziabad": {
                        "notes": "",
                        "active": 11,
                        "confirmed": 55622,
                        "migratedother": 0,
                        "deceased": 461,
                        "recovered": 55150,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Ghazipur": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 21636,
                        "migratedother": 0,
                        "deceased": 281,
                        "recovered": 21345,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gonda": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 12281,
                        "migratedother": 0,
                        "deceased": 261,
                        "recovered": 12020,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Gorakhpur": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 59377,
                        "migratedother": 0,
                        "deceased": 848,
                        "recovered": 58515,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Hamirpur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 5229,
                        "migratedother": 0,
                        "deceased": 101,
                        "recovered": 5127,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hapur": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 12628,
                        "migratedother": 0,
                        "deceased": 217,
                        "recovered": 12407,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Hardoi": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 13754,
                        "migratedother": 0,
                        "deceased": 349,
                        "recovered": 13402,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Hathras": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 2917,
                        "migratedother": 0,
                        "deceased": 43,
                        "recovered": 2874,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jalaun": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 11661,
                        "migratedother": 0,
                        "deceased": 202,
                        "recovered": 11454,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jaunpur": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 22568,
                        "migratedother": 0,
                        "deceased": 234,
                        "recovered": 22325,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Jhansi": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 36539,
                        "migratedother": 0,
                        "deceased": 663,
                        "recovered": 35869,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kannauj": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 9220,
                        "migratedother": 0,
                        "deceased": 114,
                        "recovered": 9101,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kanpur Dehat": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 6189,
                        "migratedother": 0,
                        "deceased": 110,
                        "recovered": 6074,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kanpur Nagar": {
                        "notes": "",
                        "active": 15,
                        "confirmed": 82893,
                        "migratedother": 0,
                        "deceased": 1904,
                        "recovered": 80974,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Kasganj": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 4247,
                        "migratedother": 0,
                        "deceased": 53,
                        "recovered": 4194,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Kaushambi": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 4416,
                        "migratedother": 0,
                        "deceased": 68,
                        "recovered": 4346,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Kushinagar": {
                        "notes": "",
                        "active": 37,
                        "confirmed": 15610,
                        "migratedother": 0,
                        "deceased": 228,
                        "recovered": 15345,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 12
                        }
                    },
                    "Lakhimpur Kheri": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 24405,
                        "migratedother": 0,
                        "deceased": 292,
                        "recovered": 24103,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Lalitpur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 12734,
                        "migratedother": 0,
                        "deceased": 128,
                        "recovered": 12605,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Lucknow": {
                        "notes": "",
                        "active": 54,
                        "confirmed": 238644,
                        "migratedother": 0,
                        "deceased": 2651,
                        "recovered": 235939,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 7
                        }
                    },
                    "Maharajganj": {
                        "notes": "",
                        "active": 14,
                        "confirmed": 12394,
                        "migratedother": 0,
                        "deceased": 138,
                        "recovered": 12242,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mahoba": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 4268,
                        "migratedother": 0,
                        "deceased": 86,
                        "recovered": 4181,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mainpuri": {
                        "notes": "",
                        "active": 36,
                        "confirmed": 10017,
                        "migratedother": 0,
                        "deceased": 182,
                        "recovered": 9799,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 1,
                            "recovered": 0
                        }
                    },
                    "Mathura": {
                        "notes": "",
                        "active": 40,
                        "confirmed": 20273,
                        "migratedother": 0,
                        "deceased": 368,
                        "recovered": 19865,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Mau": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 8323,
                        "migratedother": 0,
                        "deceased": 80,
                        "recovered": 8242,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Meerut": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 69420,
                        "migratedother": 0,
                        "deceased": 897,
                        "recovered": 68516,
                        "delta": {
                            "confirmed": -1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    },
                    "Mirzapur": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 11082,
                        "migratedother": 0,
                        "deceased": 116,
                        "recovered": 10964,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Moradabad": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 39094,
                        "migratedother": 0,
                        "deceased": 349,
                        "recovered": 38740,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Muzaffarnagar": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 30999,
                        "migratedother": 0,
                        "deceased": 269,
                        "recovered": 30724,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pilibhit": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 11027,
                        "migratedother": 0,
                        "deceased": 193,
                        "recovered": 10834,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Pratapgarh": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 16023,
                        "migratedother": 0,
                        "deceased": 161,
                        "recovered": 15862,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Prayagraj": {
                        "notes": "",
                        "active": 34,
                        "confirmed": 78607,
                        "migratedother": 0,
                        "deceased": 1074,
                        "recovered": 77499,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rae Bareli": {
                        "notes": "",
                        "active": 31,
                        "confirmed": 17074,
                        "migratedother": 0,
                        "deceased": 320,
                        "recovered": 16723,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Rampur": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 11817,
                        "migratedother": 0,
                        "deceased": 146,
                        "recovered": 11665,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Saharanpur": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 32749,
                        "migratedother": 0,
                        "deceased": 420,
                        "recovered": 32327,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Sambhal": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 9436,
                        "migratedother": 0,
                        "deceased": 105,
                        "recovered": 9329,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sant Kabir Nagar": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 8157,
                        "migratedother": 0,
                        "deceased": 98,
                        "recovered": 8058,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shahjahanpur": {
                        "notes": "",
                        "active": 4,
                        "confirmed": 20352,
                        "migratedother": 0,
                        "deceased": 443,
                        "recovered": 19905,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Shamli": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 12974,
                        "migratedother": 0,
                        "deceased": 45,
                        "recovered": 12929,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Shrawasti": {
                        "notes": "",
                        "active": 2,
                        "confirmed": 4385,
                        "migratedother": 0,
                        "deceased": 35,
                        "recovered": 4348,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Siddharthnagar": {
                        "notes": "",
                        "active": 5,
                        "confirmed": 9364,
                        "migratedother": 0,
                        "deceased": 100,
                        "recovered": 9259,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sitapur": {
                        "notes": "",
                        "active": 1,
                        "confirmed": 12392,
                        "migratedother": 0,
                        "deceased": 185,
                        "recovered": 12206,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Sonbhadra": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 16799,
                        "migratedother": 0,
                        "deceased": 251,
                        "recovered": 16548,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 13
                        }
                    },
                    "Sultanpur": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 14907,
                        "migratedother": 0,
                        "deceased": 138,
                        "recovered": 14763,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Unnao": {
                        "notes": "",
                        "active": 3,
                        "confirmed": 14996,
                        "migratedother": 0,
                        "deceased": 254,
                        "recovered": 14739,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Varanasi": {
                        "notes": "",
                        "active": 21,
                        "confirmed": 85466,
                        "migratedother": 0,
                        "deceased": 971,
                        "recovered": 84474,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 7
                        }
                    }
                },
                "statecode": "UP"
            },
            "Uttarakhand": {
                "districtData": {
                    "Almora": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 12139,
                        "migratedother": 607,
                        "deceased": 194,
                        "recovered": 11332,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Bageshwar": {
                        "notes": "",
                        "active": 16,
                        "confirmed": 5709,
                        "migratedother": 25,
                        "deceased": 60,
                        "recovered": 5608,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Chamoli": {
                        "notes": "",
                        "active": 53,
                        "confirmed": 12144,
                        "migratedother": 202,
                        "deceased": 62,
                        "recovered": 11827,
                        "delta": {
                            "confirmed": 4,
                            "deceased": 0,
                            "recovered": 1
                        }
                    },
                    "Champawat": {
                        "notes": "",
                        "active": 34,
                        "confirmed": 7547,
                        "migratedother": 166,
                        "deceased": 53,
                        "recovered": 7294,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Dehradun": {
                        "notes": "",
                        "active": 171,
                        "confirmed": 111951,
                        "migratedother": 576,
                        "deceased": 3512,
                        "recovered": 107692,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 1,
                            "recovered": 14
                        }
                    },
                    "Haridwar": {
                        "notes": "",
                        "active": 9,
                        "confirmed": 51397,
                        "migratedother": 1364,
                        "deceased": 1004,
                        "recovered": 49020,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Nainital": {
                        "notes": "",
                        "active": 7,
                        "confirmed": 39078,
                        "migratedother": 128,
                        "deceased": 943,
                        "recovered": 38000,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Pauri Garhwal": {
                        "notes": "",
                        "active": 10,
                        "confirmed": 17541,
                        "migratedother": 701,
                        "deceased": 313,
                        "recovered": 16517,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Pithoragarh": {
                        "notes": "",
                        "active": 58,
                        "confirmed": 10162,
                        "migratedother": 104,
                        "deceased": 180,
                        "recovered": 9820,
                        "delta": {
                            "confirmed": 6,
                            "deceased": 0,
                            "recovered": 2
                        }
                    },
                    "Rudraprayag": {
                        "notes": "",
                        "active": 23,
                        "confirmed": 8740,
                        "migratedother": 144,
                        "deceased": 106,
                        "recovered": 8467,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Tehri Garhwal": {
                        "notes": "",
                        "active": 6,
                        "confirmed": 15818,
                        "migratedother": 889,
                        "deceased": 107,
                        "recovered": 14816,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Udham Singh Nagar": {
                        "notes": "",
                        "active": 23,
                        "confirmed": 37808,
                        "migratedother": 794,
                        "deceased": 761,
                        "recovered": 36230,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Uttarkashi": {
                        "notes": "",
                        "active": 19,
                        "confirmed": 12468,
                        "migratedother": 340,
                        "deceased": 74,
                        "recovered": 12035,
                        "delta": {
                            "confirmed": 1,
                            "deceased": 0,
                            "recovered": 3
                        }
                    }
                },
                "statecode": "UT"
            },
            "West Bengal": {
                "districtData": {
                    "Alipurduar": {
                        "notes": "",
                        "active": 243,
                        "confirmed": 15027,
                        "migratedother": 0,
                        "deceased": 99,
                        "recovered": 14685,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 0,
                            "recovered": 18
                        }
                    },
                    "Bankura": {
                        "notes": "",
                        "active": 366,
                        "confirmed": 34724,
                        "migratedother": 0,
                        "deceased": 261,
                        "recovered": 34097,
                        "delta": {
                            "confirmed": 13,
                            "deceased": 0,
                            "recovered": 28
                        }
                    },
                    "Birbhum": {
                        "notes": "",
                        "active": 130,
                        "confirmed": 40424,
                        "migratedother": 0,
                        "deceased": 285,
                        "recovered": 40009,
                        "delta": {
                            "confirmed": 9,
                            "deceased": 0,
                            "recovered": 10
                        }
                    },
                    "Cooch Behar": {
                        "notes": "",
                        "active": 536,
                        "confirmed": 27938,
                        "migratedother": 0,
                        "deceased": 95,
                        "recovered": 27307,
                        "delta": {
                            "confirmed": 33,
                            "deceased": 0,
                            "recovered": 39
                        }
                    },
                    "Dakshin Dinajpur": {
                        "notes": "",
                        "active": 103,
                        "confirmed": 16976,
                        "migratedother": 0,
                        "deceased": 168,
                        "recovered": 16705,
                        "delta": {
                            "confirmed": 7,
                            "deceased": 0,
                            "recovered": 8
                        }
                    },
                    "Darjeeling": {
                        "notes": "",
                        "active": 998,
                        "confirmed": 54050,
                        "migratedother": 0,
                        "deceased": 502,
                        "recovered": 52550,
                        "delta": {
                            "confirmed": 71,
                            "deceased": 0,
                            "recovered": 73
                        }
                    },
                    "Hooghly": {
                        "notes": "",
                        "active": 565,
                        "confirmed": 82138,
                        "migratedother": 0,
                        "deceased": 924,
                        "recovered": 80649,
                        "delta": {
                            "confirmed": 28,
                            "deceased": 0,
                            "recovered": 43
                        }
                    },
                    "Howrah": {
                        "notes": "",
                        "active": 522,
                        "confirmed": 94880,
                        "migratedother": 0,
                        "deceased": 1486,
                        "recovered": 92872,
                        "delta": {
                            "confirmed": 57,
                            "deceased": 0,
                            "recovered": 38
                        }
                    },
                    "Jalpaiguri": {
                        "notes": "",
                        "active": 626,
                        "confirmed": 40269,
                        "migratedother": 0,
                        "deceased": 542,
                        "recovered": 39101,
                        "delta": {
                            "confirmed": 37,
                            "deceased": 0,
                            "recovered": 46
                        }
                    },
                    "Jhargram": {
                        "notes": "",
                        "active": 308,
                        "confirmed": 11429,
                        "migratedother": 0,
                        "deceased": 27,
                        "recovered": 11094,
                        "delta": {
                            "confirmed": 8,
                            "deceased": 0,
                            "recovered": 24
                        }
                    },
                    "Kalimpong": {
                        "notes": "",
                        "active": 274,
                        "confirmed": 6513,
                        "migratedother": 0,
                        "deceased": 44,
                        "recovered": 6195,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 1,
                            "recovered": 21
                        }
                    },
                    "Kolkata": {
                        "notes": "",
                        "active": 835,
                        "confirmed": 311183,
                        "migratedother": 0,
                        "deceased": 4981,
                        "recovered": 305367,
                        "delta": {
                            "confirmed": 78,
                            "deceased": 0,
                            "recovered": 59
                        }
                    },
                    "Malda": {
                        "notes": "",
                        "active": 67,
                        "confirmed": 32700,
                        "migratedother": 0,
                        "deceased": 185,
                        "recovered": 32448,
                        "delta": {
                            "confirmed": 5,
                            "deceased": 0,
                            "recovered": 5
                        }
                    },
                    "Murshidabad": {
                        "notes": "",
                        "active": 58,
                        "confirmed": 33633,
                        "migratedother": 0,
                        "deceased": 322,
                        "recovered": 33253,
                        "delta": {
                            "confirmed": 2,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "Nadia": {
                        "notes": "",
                        "active": 648,
                        "confirmed": 69668,
                        "migratedother": 0,
                        "deceased": 718,
                        "recovered": 68302,
                        "delta": {
                            "confirmed": 39,
                            "deceased": 3,
                            "recovered": 48
                        }
                    },
                    "North 24 Parganas": {
                        "notes": "",
                        "active": 1213,
                        "confirmed": 320162,
                        "migratedother": 0,
                        "deceased": 4591,
                        "recovered": 314358,
                        "delta": {
                            "confirmed": 89,
                            "deceased": 1,
                            "recovered": 88
                        }
                    },
                    "Other State": {
                        "notes": "",
                        "active": 0,
                        "confirmed": 66,
                        "migratedother": 0,
                        "deceased": 3,
                        "recovered": 63,
                        "delta": {
                            "confirmed": 0,
                            "deceased": 0,
                            "recovered": 0
                        }
                    },
                    "Paschim Bardhaman": {
                        "notes": "",
                        "active": 203,
                        "confirmed": 56402,
                        "migratedother": 0,
                        "deceased": 347,
                        "recovered": 55852,
                        "delta": {
                            "confirmed": 18,
                            "deceased": 0,
                            "recovered": 15
                        }
                    },
                    "Paschim Medinipur": {
                        "notes": "",
                        "active": 595,
                        "confirmed": 51094,
                        "migratedother": 0,
                        "deceased": 493,
                        "recovered": 50006,
                        "delta": {
                            "confirmed": 38,
                            "deceased": 1,
                            "recovered": 44
                        }
                    },
                    "Purba Bardhaman": {
                        "notes": "",
                        "active": 342,
                        "confirmed": 40241,
                        "migratedother": 0,
                        "deceased": 184,
                        "recovered": 39715,
                        "delta": {
                            "confirmed": 16,
                            "deceased": 0,
                            "recovered": 26
                        }
                    },
                    "Purba Medinipur": {
                        "notes": "",
                        "active": 692,
                        "confirmed": 60872,
                        "migratedother": 0,
                        "deceased": 378,
                        "recovered": 59802,
                        "delta": {
                            "confirmed": 53,
                            "deceased": 0,
                            "recovered": 50
                        }
                    },
                    "Purulia": {
                        "notes": "",
                        "active": 55,
                        "confirmed": 19205,
                        "migratedother": 0,
                        "deceased": 112,
                        "recovered": 19038,
                        "delta": {
                            "confirmed": 3,
                            "deceased": 0,
                            "recovered": 4
                        }
                    },
                    "South 24 Parganas": {
                        "notes": "",
                        "active": 658,
                        "confirmed": 96592,
                        "migratedother": 0,
                        "deceased": 1278,
                        "recovered": 94656,
                        "delta": {
                            "confirmed": 63,
                            "deceased": 0,
                            "recovered": 46
                        }
                    },
                    "Uttar Dinajpur": {
                        "notes": "",
                        "active": 126,
                        "confirmed": 19513,
                        "migratedother": 0,
                        "deceased": 233,
                        "recovered": 19154,
                        "delta": {
                            "confirmed": 15,
                            "deceased": 0,
                            "recovered": 9
                        }
                    }
                },
                "statecode": "WB"
            }
        }
    )
}

export default Districts
